import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};



export type Account = {
  __typename?: 'Account';
  id: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  nickName?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  marketingEmailOptIn?: Maybe<Scalars['Boolean']>;
  marketingSmsOptIn?: Maybe<Scalars['Boolean']>;
  preferredFranchise?: Maybe<Franchise>;
  notes?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<AccountPhone>>;
  active?: Maybe<Scalars['Boolean']>;
};

export type AccountInput = {
  email?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  nickName?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  stateProvince?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  marketingEmailOptIn?: Maybe<Scalars['Boolean']>;
  marketingSmsOptIn?: Maybe<Scalars['Boolean']>;
  preferredFranchise?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<AccountPhoneInput>>;
  active?: Maybe<Scalars['Boolean']>;
};

export type AccountPhone = {
  __typename?: 'AccountPhone';
  id: Scalars['ID'];
  geoCountry?: Maybe<GeoCountry>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneType?: Maybe<PhoneType>;
  phoneLabel?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  marketingSmsOptIn?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type AccountPhoneInput = {
  id?: Maybe<Scalars['ID']>;
  geoCountry: Scalars['ID'];
  phoneNumber: Scalars['String'];
  phoneType: Scalars['ID'];
  phoneLabel?: Maybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  marketingSmsOptIn: Scalars['Boolean'];
  active?: Maybe<Scalars['Boolean']>;
};

export type AccountTermPolicyForm = {
  __typename?: 'AccountTermPolicyForm';
  id: Scalars['ID'];
  account: Account;
  termPolicyForm: TermPolicyForm;
  documentId: Scalars['String'];
  dateSigned?: Maybe<Scalars['Date']>;
};

export type AccountTermPolicyFormInput = {
  account: Scalars['ID'];
  termPolicyForm?: Maybe<Scalars['ID']>;
  documentId: Scalars['String'];
};

export type Allergy = {
  __typename?: 'Allergy';
  id?: Maybe<Scalars['ID']>;
  attributeId: Scalars['Int'];
  name: Scalars['String'];
  description: Scalars['String'];
};

export type AllergyInput = {
  id?: Maybe<Scalars['ID']>;
  attributeId: Scalars['Int'];
  description: Scalars['String'];
};

export type Attribute = {
  __typename?: 'Attribute';
  id: Scalars['ID'];
  typeId?: Maybe<Scalars['Int']>;
  subTypeId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** A type that describes a Pet. */
export type Booking = {
  __typename?: 'Booking';
  /** The id of the booking. */
  id?: Maybe<Scalars['ID']>;
  /** The title of the booking items. */
  title?: Maybe<Scalars['String']>;
  /** The type of the booking items. */
  type?: Maybe<Scalars['String']>;
  /** The categories of the booking items. */
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The start date of the booking appointments. */
  startDate?: Maybe<Scalars['Date']>;
  /** The end date of the booking appointments. */
  endDate?: Maybe<Scalars['Date']>;
  /** The status of the booking. */
  status?: Maybe<Scalars['Int']>;
  /** The pets of the booking appointments. */
  pets?: Maybe<Array<Maybe<Pet>>>;
  /** The franchise of the booking. */
  franchise?: Maybe<Franchise>;
  /** The items of the booking appointments. */
  items?: Maybe<Array<Maybe<Item>>>;
  /** Booking decline reason */
  declineReason?: Maybe<Scalars['String']>;
};

/** A type that describes a breed. */
export type Breed = {
  __typename?: 'Breed';
  /** The id of the breed. */
  id?: Maybe<Scalars['ID']>;
  /** The name/label of the breed. */
  label?: Maybe<Scalars['String']>;
  /** Flag to indicate if the breed is active. */
  active?: Maybe<Scalars['Boolean']>;
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type CamperCampingQuizAnswer = {
  __typename?: 'CamperCampingQuizAnswer';
  choices?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type CamperCampingQuizAnswerInput = {
  choices: Array<Scalars['Int']>;
};

export type CamperCampingQuizQuestion = {
  __typename?: 'CamperCampingQuizQuestion';
  options?: Maybe<Array<CamperCampingQuizQuestionOption>>;
};

export type CamperCampingQuizQuestionOption = {
  __typename?: 'CamperCampingQuizQuestionOption';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CamperRelease = {
  __typename?: 'CamperRelease';
  id: Scalars['ID'];
};

export type CardType = {
  __typename?: 'CardType';
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
};

export type CartLineSubmissionInput = {
  itemId: Scalars['ID'];
  qty?: Maybe<Scalars['Int']>;
};

export type CartSubmissionInput = {
  franchiseId: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  lines: Array<CartLineSubmissionInput>;
};

/** A type that describes a color. */
export type Color = {
  __typename?: 'Color';
  /** The id of the color. */
  id?: Maybe<Scalars['ID']>;
  /** The name/label of the color. */
  label?: Maybe<Scalars['String']>;
  /** Flag to indicate if the color is active. */
  active?: Maybe<Scalars['Boolean']>;
};

/** A type that describes a contact. */
export type Contact = {
  __typename?: 'Contact';
  /** The contact id. */
  id: Scalars['ID'];
  /** The franchise id tied to the contact. */
  franchiseId?: Maybe<Scalars['Int']>;
  /** The first name on the contact. */
  firstName?: Maybe<Scalars['String']>;
  /** The last name on the contact. */
  lastName?: Maybe<Scalars['String']>;
  /** The email on the contact. */
  email?: Maybe<Scalars['String']>;
  /** The address line 1 on the contact. */
  address1?: Maybe<Scalars['String']>;
  /** The address line 2 on the contact. */
  address2?: Maybe<Scalars['String']>;
  /** The city on the contact. */
  city?: Maybe<Scalars['String']>;
  /** The state on the contact. */
  state?: Maybe<Scalars['String']>;
  /** The country on the contact. */
  country?: Maybe<Scalars['String']>;
  /** The zipcode on the contact. */
  zipcode?: Maybe<Scalars['String']>;
  /** The marketingEmailOptIn on the contact. */
  marketingEmailOptIn?: Maybe<Scalars['Boolean']>;
  /** The marketingTextOptIn on the contact. */
  marketingTextOptIn?: Maybe<Scalars['Boolean']>;
  /** The phones on the contact. */
  phones?: Maybe<Array<ContactPhone>>;
};

/** An input that describes what is needed to make a new contact or can be updated on a contact, minus the contact_id. */
export type ContactInput = {
  /** The franchise id tied to the contact. */
  franchiseId?: Maybe<Scalars['Int']>;
  /** The first name on the contact. */
  firstName?: Maybe<Scalars['String']>;
  /** The last name on the contact. */
  lastName?: Maybe<Scalars['String']>;
  /** The email on the contact. */
  email?: Maybe<Scalars['String']>;
  /** The address line 1 on the contact. */
  address1?: Maybe<Scalars['String']>;
  /** The address line 2 on the contact. */
  address2?: Maybe<Scalars['String']>;
  /** The city on the contact. */
  city?: Maybe<Scalars['String']>;
  /** The state on the contact. */
  state?: Maybe<Scalars['String']>;
  /** The country on the contact. */
  country?: Maybe<Scalars['String']>;
  /** The zipcode on the contact. */
  zipcode?: Maybe<Scalars['String']>;
  /** The marketingEmailOptIn on the contact. */
  marketingEmailOptIn?: Maybe<Scalars['Boolean']>;
  /** The marketingTextOptIn on the contact. */
  marketingTextOptIn?: Maybe<Scalars['Boolean']>;
  /** The phones on the contact. */
  phones?: Maybe<Array<ContactPhoneInput>>;
};

/** A type that describes a contact phone. */
export type ContactPhone = {
  __typename?: 'ContactPhone';
  /** The phone id. */
  id: Scalars['ID'];
  /** The number on the phone. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The country on the phone. */
  country?: Maybe<Scalars['String']>;
  /** The country calling code on the phone. */
  countryCallingCode?: Maybe<Scalars['String']>;
  /** The type on the phone. */
  type?: Maybe<PhoneTypeEnum>;
};

/** The input that describes what is needed to make a new contact phone or update a contact phone. */
export type ContactPhoneInput = {
  /** The phone id. */
  id?: Maybe<Scalars['ID']>;
  /** The number on the phone. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The country on the phone. */
  country?: Maybe<Scalars['String']>;
  /** The country calling code on the phone. */
  countryCallingCode?: Maybe<Scalars['String']>;
  /** The type on the phone. */
  type?: Maybe<PhoneTypeEnum>;
};

export type CustomField = {
  __typename?: 'CustomField';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  apiId?: Maybe<Scalars['String']>;
  editor?: Maybe<Scalars['String']>;
};


export type EmbeddedSignatureRequestWithTemplateInput = {
  testMode: Scalars['Boolean'];
  clientId: Scalars['String'];
  signers: Array<SignerInput>;
};

/** A type that describes a feeding. */
export type Feeding = {
  __typename?: 'Feeding';
  /** The primary id of the feeding. */
  id?: Maybe<Scalars['ID']>;
  /** The attribute id of the feeding. */
  attributeId: Scalars['Int'];
  /** The name of the food. */
  name: Scalars['String'];
  /** Flag to indicate if feeding is breakfast. */
  isBreakfast: Scalars['Boolean'];
  /** Flag to indicate if feeding is dinner. */
  isDinner: Scalars['Boolean'];
  /** The quantity of the food. */
  quantity: Scalars['String'];
  /** Any details for the feeding. */
  details?: Maybe<Scalars['String']>;
};

export type FeedingInput = {
  id?: Maybe<Scalars['ID']>;
  attributeId: Scalars['Int'];
  isBreakfast: Scalars['Boolean'];
  isDinner: Scalars['Boolean'];
  quantity: Scalars['String'];
  details?: Maybe<Scalars['String']>;
};

/** A type that describes a food. */
export type Food = {
  __typename?: 'Food';
  /** The primary id of the food. */
  id?: Maybe<Scalars['ID']>;
  /** The pet id associated with this food. */
  pet_id?: Maybe<Scalars['ID']>;
  /** The name/label of the food. */
  name?: Maybe<Scalars['String']>;
  /** The quantity to given for this food. */
  quantity?: Maybe<Scalars['String']>;
  /** A flag to indicate if the food is for breakfast. */
  is_breakfast?: Maybe<Scalars['Int']>;
  /** The details of the breakfast. */
  breakfast_details?: Maybe<Scalars['String']>;
  /** A flag to indicate if the food is for dinner. */
  is_dinner?: Maybe<Scalars['Int']>;
  /** The details of the dinner. */
  dinner_details?: Maybe<Scalars['String']>;
  /** A flag to indicate if this food is active. */
  active?: Maybe<Scalars['Int']>;
};

export type FormField = {
  __typename?: 'FormField';
  apiId?: Maybe<Scalars['String']>;
  signatureId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** A type that describes a franchise. */
export type Franchise = {
  __typename?: 'Franchise';
  /** The id of the franchise. */
  id?: Maybe<Scalars['ID']>;
  /** The franchise code. */
  code?: Maybe<Scalars['String']>;
  /** The franchise territory. */
  territory?: Maybe<Scalars['String']>;
  /** The franchise name. */
  name?: Maybe<Scalars['String']>;
  /** The address of the franchise. */
  address1?: Maybe<Scalars['String']>;
  /** The secondary address of the franchise. */
  address2?: Maybe<Scalars['String']>;
  /** The city the franchise is in. */
  city?: Maybe<Scalars['String']>;
  /** The state the franchise is in. */
  state?: Maybe<Scalars['String']>;
  /** The zipcode for the franchise. */
  zipcode?: Maybe<Scalars['String']>;
  /** The country for the franchise. */
  country?: Maybe<Scalars['String']>;
  /** The telephone number for the franchise. */
  telephone?: Maybe<Scalars['String']>;
  /** The fax for the franchise. */
  fax?: Maybe<Scalars['String']>;
  /** The tax for the franchise. */
  tax?: Maybe<Scalars['Float']>;
  /** The latitude for the franchise. */
  latitude?: Maybe<Scalars['String']>;
  /** The longitude for the franchise. */
  longitude?: Maybe<Scalars['String']>;
  /** The email for the the franchise. */
  email?: Maybe<Scalars['String']>;
  /** The website url for the the franchise. */
  websiteUrl?: Maybe<Scalars['String']>;
  /** The home buddies url for the the franchise. */
  homeBuddiesUrl?: Maybe<Scalars['String']>;
  /** The hours of operation for the franchise. */
  hoursOfOperation?: Maybe<HoursOfOperation>;
  /** The merchant information for the franchise. */
  merchant?: Maybe<FranchiseMerchant>;
  /** Whether the franchise has default tip item. */
  hasDefaultTipItem?: Maybe<Scalars['Boolean']>;
  /** Whether the franchise has credit card processing enabled. */
  creditCardProcessingEnabled?: Maybe<Scalars['Boolean']>;
};

export type FranchiseMerchant = {
  __typename?: 'FranchiseMerchant';
  id: Scalars['ID'];
  merchName?: Maybe<Scalars['String']>;
  merchEmail?: Maybe<Scalars['String']>;
  merchPhone?: Maybe<Scalars['String']>;
  merchAddr1?: Maybe<Scalars['String']>;
  merchAddr2?: Maybe<Scalars['String']>;
  merchAddr3?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  merchTippercent?: Maybe<Scalars['String']>;
};

/** A type that describes a franchise with distance. */
export type FranchiseWithDistance = {
  __typename?: 'FranchiseWithDistance';
  /** The id of the franchise. */
  id?: Maybe<Scalars['ID']>;
  /** The franchise code. */
  code?: Maybe<Scalars['String']>;
  /** The franchise territory. */
  territory?: Maybe<Scalars['String']>;
  /** The franchise name. */
  name?: Maybe<Scalars['String']>;
  /** The address of the franchise. */
  address1?: Maybe<Scalars['String']>;
  /** The secondary address of the franchise. */
  address2?: Maybe<Scalars['String']>;
  /** The city the franchise is in. */
  city?: Maybe<Scalars['String']>;
  /** The state the franchise is in. */
  state?: Maybe<Scalars['String']>;
  /** The zipcode for the franchise. */
  zipcode?: Maybe<Scalars['String']>;
  /** The country for the franchise. */
  country?: Maybe<Scalars['String']>;
  /** The telephone number for the franchise. */
  telephone?: Maybe<Scalars['String']>;
  /** The fax for the franchise. */
  fax?: Maybe<Scalars['String']>;
  /** The tax for the franchise. */
  tax?: Maybe<Scalars['Float']>;
  /** The latitude for the franchise. */
  latitude?: Maybe<Scalars['String']>;
  /** The longitude for the franchise. */
  longitude?: Maybe<Scalars['String']>;
  /** The email for the the franchise. */
  email?: Maybe<Scalars['String']>;
  /** The website url for the the franchise. */
  websiteUrl?: Maybe<Scalars['String']>;
  /** The home buddies url for the the franchise. */
  homeBuddiesUrl?: Maybe<Scalars['String']>;
  /** The hours of operation for the franchise. */
  hoursOfOperation?: Maybe<HoursOfOperation>;
  /** The merchant information for the franchise. */
  merchant?: Maybe<FranchiseMerchant>;
  /** Whether the franchise has default tip item. */
  hasDefaultTipItem?: Maybe<Scalars['Boolean']>;
  /** Whether the franchise has credit card processing enabled. */
  creditCardProcessingEnabled?: Maybe<Scalars['Boolean']>;
  /** The distance in miles to the franchise from search point. */
  distanceInMi?: Maybe<Scalars['Float']>;
  /** The distance in kilometers to the franchise from search point. */
  distanceInKm?: Maybe<Scalars['Float']>;
};

/** An enum that describes a gender. */
export enum Gender {
  M = 'M',
  F = 'F',
  U = 'U'
}

export type GeoCountry = {
  __typename?: 'GeoCountry';
  id: Scalars['ID'];
  countryIso: Scalars['String'];
  countryIsoThree?: Maybe<Scalars['String']>;
  countryCallingCode: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

/** A type that describes the hours of operation for a franchise. */
export type HoursOfOperation = {
  __typename?: 'HoursOfOperation';
  /** Holds the Sunday hours. */
  sunday?: Maybe<Scalars['String']>;
  /** Holds the Monday hours. */
  monday?: Maybe<Scalars['String']>;
  /** Holds the Tuesday hours. */
  tuesday?: Maybe<Scalars['String']>;
  /** Holds the Wednesday hours. */
  wednesday?: Maybe<Scalars['String']>;
  /** Holds the Thursday hours. */
  thursday?: Maybe<Scalars['String']>;
  /** Holds the Friday hours. */
  friday?: Maybe<Scalars['String']>;
  /** Holds the Saturday hours. */
  saturday?: Maybe<Scalars['String']>;
};

export type InterviewRequest = {
  __typename?: 'InterviewRequest';
  id: Scalars['ID'];
};

export type InterviewRequestInput = {
  franchiseId: Scalars['ID'];
  notes: Scalars['String'];
  pets: Array<Scalars['ID']>;
};

export type Item = {
  __typename?: 'Item';
  id: Scalars['ID'];
  label: Scalars['String'];
  displayName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  type: ItemType;
  category: ItemCategory;
  price: Scalars['Float'];
  franchise?: Maybe<Franchise>;
  taxable?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<PackageItem>>;
};

export type ItemCategory = {
  __typename?: 'ItemCategory';
  id: Scalars['ID'];
  label: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
  typeId: Scalars['ID'];
  active: Scalars['Boolean'];
};

export type ItemType = {
  __typename?: 'ItemType';
  id: Scalars['ID'];
  label: Scalars['String'];
  active: Scalars['Boolean'];
};

export type ListInfo = {
  __typename?: 'ListInfo';
  page?: Maybe<Scalars['Int']>;
  numPages?: Maybe<Scalars['Int']>;
  numResults?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type MarketingTile = {
  __typename?: 'MarketingTile';
  id: Scalars['ID'];
  imagePath?: Maybe<Scalars['String']>;
  altText?: Maybe<Scalars['String']>;
};

/** A type that describes a medication. */
export type Medication = {
  __typename?: 'Medication';
  /** The primary id of the medication. */
  id?: Maybe<Scalars['ID']>;
  /** The attribute id of the medication. */
  attributeId: Scalars['Int'];
  /** The name of the medication. */
  name: Scalars['String'];
  /** Flag to indicate if the medication should be taken in the morning. */
  isMorning: Scalars['Boolean'];
  /** Flag to indicate if the medication should be taken in the afternoon. */
  isAfternoon: Scalars['Boolean'];
  /** The dosage amount of the medication. */
  dosage: Scalars['String'];
  /** Any notes for the medication. */
  notes?: Maybe<Scalars['String']>;
};

export type MedicationInput = {
  id?: Maybe<Scalars['ID']>;
  attributeId: Scalars['Int'];
  isMorning: Scalars['Boolean'];
  isAfternoon: Scalars['Boolean'];
  dosage: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a pet */
  addPet?: Maybe<Pet>;
  /** Update a pet - Camper Details */
  updatePet?: Maybe<Pet>;
  /** Remove a Pet */
  removePet?: Maybe<Scalars['Boolean']>;
  /** Updates the data for an account. */
  updateAccount?: Maybe<Account>;
  /** Adds a new account. */
  addAccount?: Maybe<Account>;
  /** Update preferred location for an account */
  updatePreferredLocation?: Maybe<Scalars['Boolean']>;
  /** Add a relation contact */
  addRelationContact?: Maybe<RelationContact>;
  /** Update a relation contact */
  updateRelationContact?: Maybe<RelationContact>;
  /** Delete a relation contact */
  deleteRelationContact?: Maybe<Scalars['Boolean']>;
  /** Submit "Camper Camping Quiz" questionnaire response  */
  addCamperCampingQuizAnswer?: Maybe<Scalars['Boolean']>;
  /** Create Reservation Request */
  addReservationRequest: Booking;
  /** Submit Interview Request */
  addInterviewRequest: Booking;
  /** Create Order */
  addOrder: Order;
  /** Update Order */
  updateOrder: Order;
  /** Make payment */
  payWithCreditCard?: Maybe<Array<OrderPayment>>;
  /** Create payment card */
  addPaymentCard: PaymentCard;
  /** Update payment card */
  updatePaymentCard: PaymentCard;
  /** Delete a payment card */
  deletePaymentCard?: Maybe<Scalars['Boolean']>;
  /** Create account term policy form */
  addAccountTermPolicyForm: AccountTermPolicyForm;
  /** Delete an account term policy form */
  deleteAccountTermPolicyForm?: Maybe<Scalars['Boolean']>;
  /** Create embedded signature request with template */
  createEmbeddedSignatureRequestWithTemplate: SignatureRequest;
};


export type MutationAddPetArgs = {
  pet: PetInput;
};


export type MutationUpdatePetArgs = {
  petId: Scalars['ID'];
  pet: PetInput;
};


export type MutationRemovePetArgs = {
  petId: Scalars['ID'];
  removal: PetRemovalInput;
};


export type MutationUpdateAccountArgs = {
  accountId: Scalars['ID'];
  account: AccountInput;
  forRegistration?: Maybe<Scalars['Boolean']>;
};


export type MutationAddAccountArgs = {
  account: AccountInput;
};


export type MutationUpdatePreferredLocationArgs = {
  accountId: Scalars['ID'];
  locationId: Scalars['ID'];
};


export type MutationAddRelationContactArgs = {
  accountId: Scalars['ID'];
  relationContact: RelationContactInput;
};


export type MutationUpdateRelationContactArgs = {
  accountId: Scalars['ID'];
  relationContactId: Scalars['ID'];
  relationContact: RelationContactInput;
};


export type MutationDeleteRelationContactArgs = {
  accountId: Scalars['ID'];
  relationContactId: Scalars['ID'];
};


export type MutationAddCamperCampingQuizAnswerArgs = {
  accountId: Scalars['ID'];
  answer: CamperCampingQuizAnswerInput;
};


export type MutationAddReservationRequestArgs = {
  reservationRequest: ReservationRequestInput;
};


export type MutationAddInterviewRequestArgs = {
  interviewRequest: InterviewRequestInput;
};


export type MutationAddOrderArgs = {
  cart: CartSubmissionInput;
};


export type MutationUpdateOrderArgs = {
  orderId: Scalars['ID'];
  order: OrderInput;
};


export type MutationPayWithCreditCardArgs = {
  orderId: Scalars['ID'];
  remittancePayment: RemittancePaymentInput;
};


export type MutationAddPaymentCardArgs = {
  paymentCard: PaymentCardInput;
};


export type MutationUpdatePaymentCardArgs = {
  paymentCardId: Scalars['ID'];
  paymentCard: PaymentCardInput;
};


export type MutationDeletePaymentCardArgs = {
  paymentCardId: Scalars['ID'];
};


export type MutationAddAccountTermPolicyFormArgs = {
  accountTermPolicyForm: AccountTermPolicyFormInput;
  uploadSignedFileToS3?: Maybe<Scalars['Boolean']>;
};


export type MutationDeleteAccountTermPolicyFormArgs = {
  accountTermPolicyFormId: Scalars['ID'];
};


export type MutationCreateEmbeddedSignatureRequestWithTemplateArgs = {
  termPolicyFormId: Scalars['ID'];
  embeddedSignatureRequestWithTemplate: EmbeddedSignatureRequestWithTemplateInput;
};

/** A type that describes a Order. */
export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  dateDue: Scalars['Date'];
  exchangeRate?: Maybe<Scalars['Float']>;
  dateVoided?: Maybe<Scalars['Date']>;
  dateClosed?: Maybe<Scalars['Date']>;
  account: Contact;
  franchise: Franchise;
  records?: Maybe<Array<Maybe<Record>>>;
  status: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Maybe<OrderPayment>>>;
};

export type OrderInput = {
  status: Scalars['Int'];
};

export type OrderPayment = {
  __typename?: 'OrderPayment';
  order: Order;
  payment: Payment;
  usdAmount?: Maybe<Scalars['Float']>;
  localAmount?: Maybe<Scalars['Float']>;
};

export type PackageItem = {
  __typename?: 'PackageItem';
  item: Item;
  quantity: Scalars['Int'];
};

export type Payment = {
  __typename?: 'Payment';
  id?: Maybe<Scalars['ID']>;
  franchise?: Maybe<Franchise>;
  type?: Maybe<PaymentType>;
  card?: Maybe<CardType>;
  usdAmount?: Maybe<Scalars['Float']>;
  localAmount?: Maybe<Scalars['Float']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  refId?: Maybe<Scalars['Int']>;
  reference?: Maybe<Scalars['String']>;
  voided?: Maybe<Scalars['Boolean']>;
  dateVoided?: Maybe<Scalars['Date']>;
  remittance?: Maybe<Remittance>;
};

/** A type that describes a payment card. */
export type PaymentCard = {
  __typename?: 'PaymentCard';
  id: Scalars['ID'];
  cardToken: Scalars['String'];
  /** Credit card number, masked except for the last 4 digits */
  cardAccount?: Maybe<Scalars['String']>;
  /** For example 'VISA' */
  cardType?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  cardNickname?: Maybe<Scalars['String']>;
  cardExpirationDate?: Maybe<Scalars['Date']>;
  lastTransactionDate?: Maybe<Scalars['Date']>;
  isPrimary: Scalars['Boolean'];
};

/** A input that describes a payment card. */
export type PaymentCardInput = {
  /** When adding a card, this is the TranSafe card shield ticket from iframe, when editing a card, this is the permanent token stored in db and it's optional */
  cardToken?: Maybe<Scalars['String']>;
  cardAccount?: Maybe<Scalars['String']>;
  franchise?: Maybe<Scalars['ID']>;
  cardType?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  cardNickname?: Maybe<Scalars['String']>;
  cardExpirationDate?: Maybe<Scalars['Date']>;
  lastTransactionDate?: Maybe<Scalars['Date']>;
  isPrimary: Scalars['Boolean'];
};

export type PaymentType = {
  __typename?: 'PaymentType';
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
};

/** A type that describes a Pet. */
export type Pet = {
  __typename?: 'Pet';
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  nickName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  gender?: Maybe<Gender>;
  statusId?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Boolean']>;
  isTreat?: Maybe<Scalars['Boolean']>;
  spayNeutered?: Maybe<Scalars['Boolean']>;
  breeds?: Maybe<Array<PetBreed>>;
  colors?: Maybe<Array<PetColor>>;
  weight?: Maybe<PetWeight>;
  vets?: Maybe<Array<PetVet>>;
  vaccines?: Maybe<Array<PetVaccine>>;
  allergies?: Maybe<Array<Allergy>>;
  feedings?: Maybe<Array<Feeding>>;
  medications?: Maybe<Array<Medication>>;
  camperReleases?: Maybe<Array<CamperRelease>>;
};

/** A type that describes a breed. */
export type PetBreed = {
  __typename?: 'PetBreed';
  breed: Breed;
  isPrimary: Scalars['Boolean'];
};

export type PetBreedInput = {
  breed: Scalars['Int'];
  isPrimary: Scalars['Boolean'];
};

/** A type that describes a color. */
export type PetColor = {
  __typename?: 'PetColor';
  color: Color;
  isPrimary: Scalars['Boolean'];
};

export type PetColorInput = {
  color: Scalars['Int'];
  isPrimary: Scalars['Boolean'];
};

/** An input that describes a Pet. */
export type PetInput = {
  firstName?: Maybe<Scalars['String']>;
  nickName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  gender?: Maybe<Scalars['String']>;
  isTreat?: Maybe<Scalars['Boolean']>;
  spayNeutered?: Maybe<Scalars['Boolean']>;
  breeds?: Maybe<Array<PetBreedInput>>;
  colors?: Maybe<Array<PetColorInput>>;
  weight?: Maybe<Scalars['Int']>;
  vets?: Maybe<Array<PetVetInput>>;
  allergies?: Maybe<Array<AllergyInput>>;
  feedings?: Maybe<Array<FeedingInput>>;
  medications?: Maybe<Array<MedicationInput>>;
};

export type PetRemovalInput = {
  deceased: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
};

/** A type that describes a vaccination on a pet. */
export type PetVaccination = {
  __typename?: 'PetVaccination';
  id: Scalars['ID'];
  petId: Scalars['ID'];
  vaccineId?: Maybe<Scalars['ID']>;
  documentUrl: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
};

/** A type that describes a vaccine on a pet. */
export type PetVaccine = {
  __typename?: 'PetVaccine';
  expiresOn?: Maybe<Scalars['Date']>;
  memo?: Maybe<Scalars['String']>;
  vaccinationStatus?: Maybe<Scalars['String']>;
  vaccine: Vaccine;
};

export type PetVet = {
  __typename?: 'PetVet';
  vet: Vet;
  isPrimary: Scalars['Boolean'];
};

export type PetVetInput = {
  vet: Scalars['Int'];
  isPrimary: Scalars['Boolean'];
};

export type PetWeight = {
  __typename?: 'PetWeight';
  id: Scalars['ID'];
  franchiseId: Scalars['ID'];
  weight: Scalars['Int'];
};

/** A type that describes a Pet with status. */
export type PetWithStatus = {
  __typename?: 'PetWithStatus';
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  nickName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  gender?: Maybe<Gender>;
  statusId?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Boolean']>;
  isTreat?: Maybe<Scalars['Boolean']>;
  spayNeutered?: Maybe<Scalars['Boolean']>;
  breeds?: Maybe<Array<PetBreed>>;
  colors?: Maybe<Array<PetColor>>;
  weight?: Maybe<PetWeight>;
  vets?: Maybe<Array<PetVet>>;
  vaccines?: Maybe<Array<PetVaccine>>;
  allergies?: Maybe<Array<Allergy>>;
  feedings?: Maybe<Array<Feeding>>;
  medications?: Maybe<Array<Medication>>;
  camperReleases?: Maybe<Array<CamperRelease>>;
  upcomingBookings?: Maybe<Array<Maybe<Booking>>>;
  waitlistBookings?: Maybe<Array<Maybe<Booking>>>;
  reservationRequests?: Maybe<Array<Maybe<Booking>>>;
  numberOfUnverifiedPetVaccinations?: Maybe<Scalars['Int']>;
};

export type PhoneType = {
  __typename?: 'PhoneType';
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Int']>;
};

/** An enum that describes a contact phone type. */
export enum PhoneTypeEnum {
  Home = 'Home',
  Cell = 'Cell',
  Work = 'Work',
  Fax = 'Fax',
  WorkCell = 'WorkCell',
  Unknown = 'Unknown'
}

export type Query = {
  __typename?: 'Query';
  /** Get a location */
  getLocation?: Maybe<Franchise>;
  /** Fetch Nearest Franchises */
  getNearestFranchises?: Maybe<Array<FranchiseWithDistance>>;
  /** Get info of "available" items, add-ons and packages */
  getAvailableItems?: Maybe<Array<Item>>;
  /** Get TranSafe iframe hash */
  createIFrameHash: TranSafeIFrameHash;
  /** Get a pet */
  getPet?: Maybe<Pet>;
  /** Get list of pets */
  getPetsWithStatus?: Maybe<Array<PetWithStatus>>;
  /** Get list of pet vaccinations */
  getPetVaccinations?: Maybe<Array<PetVaccination>>;
  /** Get the data for an account. */
  getAccount?: Maybe<Account>;
  /** Get preferred location */
  getPreferredLocation?: Maybe<Franchise>;
  /** Get list of other (visited) locations */
  getVisitedLocations?: Maybe<Array<Franchise>>;
  /** Get list of relation contacts */
  getRelationContacts?: Maybe<Array<RelationContact>>;
  /** Get a relation contact */
  getRelationContact?: Maybe<RelationContact>;
  /** Get account id by email */
  getAccountId?: Maybe<Scalars['ID']>;
  /** Get primary contact */
  getPrimaryContact?: Maybe<Contact>;
  /** Check email existing */
  isEmailExist: Scalars['Boolean'];
  /** Get list of payment cards */
  getPaymentCards?: Maybe<Array<PaymentCard>>;
  /** Get "Camper Camping Quiz" answer */
  getCamperCampingQuizAnswer?: Maybe<CamperCampingQuizAnswer>;
  /** Get list of upcoming booking */
  getUpcomingBookings?: Maybe<Array<Booking>>;
  /** Get list of waitlist booking */
  getWaitlistBookings?: Maybe<Array<Booking>>;
  /** Get list of reservation requests */
  getReservationRequests?: Maybe<Array<Booking>>;
  /** Get list of breeds */
  getBreeds?: Maybe<Array<Breed>>;
  /** Get list of colors */
  getColors?: Maybe<Array<Color>>;
  /** Get list of item types */
  getItemTypes?: Maybe<Array<ItemType>>;
  /** Get list of item categories */
  getItemCategories?: Maybe<Array<ItemCategory>>;
  /** Get list of vaccines */
  getVaccines?: Maybe<Array<Vaccine>>;
  /** Get list of camper camping quiz question */
  getCamperCampingQuizQuestion: CamperCampingQuizQuestion;
  /** Get list of marketing tiles */
  getMarketingTiles?: Maybe<Array<MarketingTile>>;
  /** Get list of term policy forms */
  getTermPolicyForms?: Maybe<Array<TermPolicyForm>>;
  /** Get list of phone types */
  getPhoneTypes?: Maybe<Array<PhoneType>>;
  /** Get list of geo countries */
  getGeoCountries?: Maybe<Array<GeoCountry>>;
  /** Get list of payment types */
  getPaymentTypes?: Maybe<Array<PaymentType>>;
  /** Get list of card types */
  getCardTypes?: Maybe<Array<CardType>>;
  /** Get list of medications */
  getMedications?: Maybe<Array<Attribute>>;
  /** Fetch Nearest Vets */
  getNearestVets?: Maybe<Array<VetWithDistance>>;
  /** Get an upcoming booking */
  getUpcomingBooking?: Maybe<Booking>;
  /** Get an waitlist booking */
  getWaitlistBooking?: Maybe<Booking>;
  /** Get a reservation request */
  getReservationRequest?: Maybe<Booking>;
  /** Determine if a "pending" reservation is conflicting with any existing one in DD */
  hasExistingReservations?: Maybe<Array<Booking>>;
  /** Get an order */
  getOrder?: Maybe<Order>;
  /** Get a payment card */
  getPaymentCard?: Maybe<PaymentCard>;
  /** Get list of account term policy forms */
  getAccountTermPolicyForms?: Maybe<Array<AccountTermPolicyForm>>;
  /** Get an account term policy form */
  getAccountTermPolicyForm?: Maybe<AccountTermPolicyForm>;
  /** Get files */
  getSignatureRequestFiles?: Maybe<Scalars['String']>;
  /** Get a signature request */
  getSignatureRequest?: Maybe<SignatureRequest>;
  /** Get list of signature requests */
  getSignatureRequests?: Maybe<SignatureRequests>;
};


export type QueryGetLocationArgs = {
  locationId: Scalars['ID'];
};


export type QueryGetNearestFranchisesArgs = {
  postalCode: Scalars['String'];
  radius: Scalars['Int'];
  unit: UnitOfDistance;
};


export type QueryGetAvailableItemsArgs = {
  locationId: Scalars['ID'];
};


export type QueryCreateIFrameHashArgs = {
  locationId: Scalars['ID'];
  parameters: TranSafeIFrameParametersInput;
};


export type QueryGetPetArgs = {
  petId: Scalars['ID'];
};


export type QueryGetPetsWithStatusArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetPetVaccinationsArgs = {
  petId: Scalars['ID'];
};


export type QueryGetAccountArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetPreferredLocationArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetVisitedLocationsArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetRelationContactsArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetRelationContactArgs = {
  accountId: Scalars['ID'];
  relationContactId: Scalars['ID'];
};


export type QueryGetAccountIdArgs = {
  email?: Maybe<Scalars['String']>;
};


export type QueryGetPrimaryContactArgs = {
  accountId: Scalars['ID'];
};


export type QueryIsEmailExistArgs = {
  email?: Maybe<Scalars['String']>;
};


export type QueryGetPaymentCardsArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetCamperCampingQuizAnswerArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetUpcomingBookingsArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetWaitlistBookingsArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetReservationRequestsArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetBreedsArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
};


export type QueryGetColorsArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
};


export type QueryGetItemTypesArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
};


export type QueryGetItemCategoriesArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
};


export type QueryGetVaccinesArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['String']>;
};


export type QueryGetTermPolicyFormsArgs = {
  franchiseId?: Maybe<Scalars['ID']>;
};


export type QueryGetMedicationsArgs = {
  search?: Maybe<Scalars['String']>;
};


export type QueryGetNearestVetsArgs = {
  postalCode: Scalars['String'];
  radius: Scalars['Int'];
  unit: UnitOfDistance;
};


export type QueryGetUpcomingBookingArgs = {
  bookingId: Scalars['ID'];
};


export type QueryGetWaitlistBookingArgs = {
  waitlistBookingId: Scalars['ID'];
};


export type QueryGetReservationRequestArgs = {
  reservationRequestId: Scalars['ID'];
};


export type QueryHasExistingReservationsArgs = {
  reservationService: ReservationServiceInput;
};


export type QueryGetOrderArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetPaymentCardArgs = {
  paymentCardId: Scalars['ID'];
};


export type QueryGetAccountTermPolicyFormsArgs = {
  accountId: Scalars['ID'];
};


export type QueryGetAccountTermPolicyFormArgs = {
  accountTermPolicyFormId: Scalars['ID'];
};


export type QueryGetSignatureRequestFilesArgs = {
  accountTermPolicyFormId: Scalars['ID'];
};


export type QueryGetSignatureRequestArgs = {
  documentId: Scalars['String'];
};


export type QueryGetSignatureRequestsArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
};

/** A type that describes a Record. */
export type Record = {
  __typename?: 'Record';
  id: Scalars['ID'];
  taxRate?: Maybe<Scalars['Float']>;
  usdSubtotal?: Maybe<Scalars['Float']>;
  localSubtotal?: Maybe<Scalars['Float']>;
  usdTaxTotal?: Maybe<Scalars['Float']>;
  localTaxTotal?: Maybe<Scalars['Float']>;
  usdPaymentTotal?: Maybe<Scalars['Float']>;
  localPaymentTotal?: Maybe<Scalars['Float']>;
  usdUnitPrice?: Maybe<Scalars['Float']>;
  localUnitPrice?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  item?: Maybe<Item>;
  dateVoided?: Maybe<Scalars['Date']>;
};

/** A type that describes a relation contact. */
export type RelationContact = {
  __typename?: 'RelationContact';
  /** The contact id. */
  id: Scalars['ID'];
  /** The franchise id tied to the relation contact. */
  franchiseId?: Maybe<Scalars['Int']>;
  /** The first name on the relation contact. */
  firstName?: Maybe<Scalars['String']>;
  /** The last name on the relation contact. */
  lastName?: Maybe<Scalars['String']>;
  /** The email on the relation contact. */
  email?: Maybe<Scalars['String']>;
  /** The address line 1 on the relation contact. */
  address1?: Maybe<Scalars['String']>;
  /** The address line 2 on the relation contact. */
  address2?: Maybe<Scalars['String']>;
  /** The city on the relation contact. */
  city?: Maybe<Scalars['String']>;
  /** The state on the relation contact. */
  state?: Maybe<Scalars['String']>;
  /** The country on the relation contact. */
  country?: Maybe<Scalars['String']>;
  /** The zipcode on the relation contact. */
  zipcode?: Maybe<Scalars['String']>;
  /** The marketingEmailOptIn on the relation contact. */
  marketingEmailOptIn?: Maybe<Scalars['Boolean']>;
  /** The marketingTextOptIn on the relation contact. */
  marketingTextOptIn?: Maybe<Scalars['Boolean']>;
  /** The phones on the relation contact. */
  phones?: Maybe<Array<ContactPhone>>;
  /** If a related contact on the relation contact. */
  isRelated?: Maybe<Scalars['Boolean']>;
  /** The relationship on the relation contact. */
  relationship?: Maybe<Scalars['String']>;
  /** If a mergency contact on the relation contact. */
  isEmergencyContact?: Maybe<Scalars['Boolean']>;
};

/** An input that describes what is needed to make a new relation contact or can be updated on a relation contact, minus the contact_id. */
export type RelationContactInput = {
  /** The franchise id tied to the relation contact. */
  franchiseId?: Maybe<Scalars['Int']>;
  /** The first name on the relation contact. */
  firstName?: Maybe<Scalars['String']>;
  /** The last name on the relation contact. */
  lastName?: Maybe<Scalars['String']>;
  /** The email on the relation contact. */
  email?: Maybe<Scalars['String']>;
  /** The address line 1 on the relation contact. */
  address1?: Maybe<Scalars['String']>;
  /** The address line 2 on the relation contact. */
  address2?: Maybe<Scalars['String']>;
  /** The city on the relation contact. */
  city?: Maybe<Scalars['String']>;
  /** The state on the relation contact. */
  state?: Maybe<Scalars['String']>;
  /** The country on the relation contact. */
  country?: Maybe<Scalars['String']>;
  /** The zipcode on the relation contact. */
  zipcode?: Maybe<Scalars['String']>;
  /** The marketingEmailOptIn on the relation contact. */
  marketingEmailOptIn?: Maybe<Scalars['Boolean']>;
  /** The marketingTextOptIn on the relation contact. */
  marketingTextOptIn?: Maybe<Scalars['Boolean']>;
  /** The phones on the relation contact. */
  phones?: Maybe<Array<ContactPhoneInput>>;
  /** If a related contact on the relation contact. */
  isRelated?: Maybe<Scalars['Boolean']>;
  /** The relationship on the relation contact. */
  relationship?: Maybe<Scalars['String']>;
  /** If a mergency contact on the relation contact. */
  isEmergencyContact?: Maybe<Scalars['Boolean']>;
};

export type Remittance = {
  __typename?: 'Remittance';
  transactionDate?: Maybe<Scalars['Date']>;
};

export type RemittancePaymentInput = {
  paymentType: Scalars['ID'];
  cardType: Scalars['ID'];
  amount?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  paymentCard?: Maybe<Scalars['ID']>;
  cardToken?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  cardZip?: Maybe<Scalars['String']>;
  tip?: Maybe<Scalars['Float']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  id: Scalars['ID'];
};

export type ReservationRequestInput = {
  franchiseId: Scalars['ID'];
  notes: Scalars['String'];
  services: Array<ReservationServiceInput>;
};

export type ReservationServiceInput = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  petId: Scalars['ID'];
  serviceItemId?: Maybe<Scalars['ID']>;
};

export type Signature = {
  __typename?: 'Signature';
  signatureId?: Maybe<Scalars['String']>;
  signerEmailAddress?: Maybe<Scalars['String']>;
  signerName?: Maybe<Scalars['String']>;
  signerRole?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
  declineReason?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['Date']>;
  lastViewedAt?: Maybe<Scalars['Date']>;
  lastRemindedAt?: Maybe<Scalars['Date']>;
  hasPin?: Maybe<Scalars['Boolean']>;
  reassignedBy?: Maybe<Scalars['String']>;
  reassignmentReason?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type SignatureRequest = {
  __typename?: 'SignatureRequest';
  testMode?: Maybe<Scalars['Boolean']>;
  signatureRequestId?: Maybe<Scalars['String']>;
  requesterEmailAddress?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  isDeclined?: Maybe<Scalars['Boolean']>;
  hasError?: Maybe<Scalars['Boolean']>;
  finalCopyUri?: Maybe<Scalars['String']>;
  filesUrl?: Maybe<Scalars['String']>;
  signingUrl?: Maybe<Scalars['String']>;
  detailsUrl?: Maybe<Scalars['String']>;
  signingRedirectUrl?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<CustomField>>;
  responseData?: Maybe<Array<FormField>>;
  signatures?: Maybe<Array<Signature>>;
  embeddedSignUrl?: Maybe<Scalars['String']>;
  warningMsg?: Maybe<Scalars['String']>;
  warningName?: Maybe<Scalars['String']>;
};

/** A type that describes a HelloSign signature requests. */
export type SignatureRequests = {
  __typename?: 'SignatureRequests';
  listInfo?: Maybe<ListInfo>;
  signatureRequests?: Maybe<Array<SignatureRequest>>;
  warningMsg?: Maybe<Scalars['String']>;
  warningName?: Maybe<Scalars['String']>;
};

export type SignerInput = {
  roleName: Scalars['String'];
  name: Scalars['String'];
  emailAddress: Scalars['String'];
};

export type TermPolicyForm = {
  __typename?: 'TermPolicyForm';
  id: Scalars['ID'];
  version?: Maybe<Scalars['String']>;
  geoCountry?: Maybe<GeoCountry>;
  templateId?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['Date']>;
};

export type TranSafeIFrameHash = {
  __typename?: 'TranSafeIFrameHash';
  iFrameAttributes: Scalars['String'];
  hash: Scalars['String'];
};

export type TranSafeIFrameParametersInput = {
  domain: Scalars['String'];
  cssUrl?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['Boolean']>;
  street?: Maybe<Scalars['Boolean']>;
  zip?: Maybe<Scalars['Boolean']>;
  expdateFormat?: Maybe<Scalars['String']>;
  cardholderNameFormat?: Maybe<Scalars['String']>;
  autoReload?: Maybe<Scalars['Boolean']>;
  autocomplete?: Maybe<Scalars['Boolean']>;
  includeSubmitButton?: Maybe<Scalars['Boolean']>;
};

/** An enum that describes a unit of distance. */
export enum UnitOfDistance {
  Mi = 'MI',
  Km = 'KM'
}


/** A type that describes a vaccine. */
export type Vaccine = {
  __typename?: 'Vaccine';
  /** The id of the vaccine. */
  id: Scalars['ID'];
  /** The name of the vaccine. */
  name: Scalars['String'];
  /** Flag to indicate if the vaccine is active. */
  active: Scalars['Boolean'];
  /** Flag to indicate if the vaccine is required. */
  required: Scalars['Boolean'];
  /** The notes of the vaccine. */
  notes?: Maybe<Scalars['String']>;
};

/** A type that describes a vet. */
export type Vet = {
  __typename?: 'Vet';
  /** The id of the vet. */
  id?: Maybe<Scalars['ID']>;
  /** The vet name. */
  practiceName?: Maybe<Scalars['String']>;
  /** The address of the vet. */
  address1?: Maybe<Scalars['String']>;
  /** The secondary address of the vet. */
  address2?: Maybe<Scalars['String']>;
  /** The city the vet is in. */
  city?: Maybe<Scalars['String']>;
  /** The state the vet is in. */
  state?: Maybe<Scalars['String']>;
  /** The zipcode for the vet. */
  zipcode?: Maybe<Scalars['String']>;
  /** The email for the vet. */
  email?: Maybe<Scalars['String']>;
  /** The phones on the vet. */
  phones?: Maybe<Array<VetPhone>>;
  /** The distance to the vet from search point. */
  distance?: Maybe<Scalars['Float']>;
  /** The latitude of the vet. */
  latitude?: Maybe<Scalars['Float']>;
  /** The longitude of the vet. */
  longitude?: Maybe<Scalars['Float']>;
};

/** A type that describes a contact phone. */
export type VetPhone = {
  __typename?: 'VetPhone';
  /** The phone id. */
  id: Scalars['ID'];
  /** The number on the phone. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The country on the phone. */
  country?: Maybe<Scalars['String']>;
  /** The country calling code on the phone. */
  countryCallingCode?: Maybe<Scalars['String']>;
  /** The type on the phone. */
  type?: Maybe<PhoneTypeEnum>;
};

/** A type that describes a vet with distance. */
export type VetWithDistance = {
  __typename?: 'VetWithDistance';
  /** The id of the vet. */
  id?: Maybe<Scalars['ID']>;
  /** The vet name. */
  practiceName?: Maybe<Scalars['String']>;
  /** The address of the vet. */
  address1?: Maybe<Scalars['String']>;
  /** The secondary address of the vet. */
  address2?: Maybe<Scalars['String']>;
  /** The city the vet is in. */
  city?: Maybe<Scalars['String']>;
  /** The state the vet is in. */
  state?: Maybe<Scalars['String']>;
  /** The zipcode for the vet. */
  zipcode?: Maybe<Scalars['String']>;
  /** The country for the vet. */
  country?: Maybe<Scalars['String']>;
  /** The email for the vet. */
  email?: Maybe<Scalars['String']>;
  /** The phones on the vet. */
  phones?: Maybe<Array<VetPhone>>;
  /** The latitude of the vet. */
  latitude?: Maybe<Scalars['Float']>;
  /** The longitude of the vet. */
  longitude?: Maybe<Scalars['Float']>;
  /** The distance in miles to the vet from search point. */
  distanceInMi?: Maybe<Scalars['Float']>;
  /** The distance in kilometers to the vet from search point. */
  distanceInKm?: Maybe<Scalars['Float']>;
};

export type AddAccountMutationVariables = Exact<{
  accountInput: AccountInput;
}>;


export type AddAccountMutation = (
  { __typename?: 'Mutation' }
  & { addAccount?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'firstName' | 'lastName' | 'email'>
    & { phones?: Maybe<Array<(
      { __typename?: 'AccountPhone' }
      & Pick<AccountPhone, 'phoneNumber'>
    )>>, preferredFranchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id'>
    )> }
  )> }
);

export type AddAccountTermPolicyFormMutationVariables = Exact<{
  accountTermPolicyForm: AccountTermPolicyFormInput;
  uploadSignedFileToS3: Scalars['Boolean'];
}>;


export type AddAccountTermPolicyFormMutation = (
  { __typename?: 'Mutation' }
  & { addAccountTermPolicyForm: (
    { __typename?: 'AccountTermPolicyForm' }
    & Pick<AccountTermPolicyForm, 'id' | 'documentId' | 'dateSigned'>
    & { termPolicyForm: (
      { __typename?: 'TermPolicyForm' }
      & Pick<TermPolicyForm, 'id' | 'version' | 'templateId'>
      & { geoCountry?: Maybe<(
        { __typename?: 'GeoCountry' }
        & Pick<GeoCountry, 'id' | 'countryIso' | 'name' | 'countryCallingCode'>
      )> }
    ) }
  ) }
);

export type AddCamperCampingQuizAnswerMutationVariables = Exact<{
  accountId: Scalars['ID'];
  answer: CamperCampingQuizAnswerInput;
}>;


export type AddCamperCampingQuizAnswerMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addCamperCampingQuizAnswer'>
);

export type AddInterviewRequestMutationVariables = Exact<{
  interviewRequest: InterviewRequestInput;
}>;


export type AddInterviewRequestMutation = (
  { __typename?: 'Mutation' }
  & { addInterviewRequest: (
    { __typename?: 'Booking' }
    & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status'>
    & { pets?: Maybe<Array<Maybe<(
      { __typename?: 'Pet' }
      & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
    )>>>, franchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
    )>, items?: Maybe<Array<Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
      & { type: (
        { __typename?: 'ItemType' }
        & Pick<ItemType, 'id' | 'label' | 'active'>
      ), category: (
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
      ) }
    )>>> }
  ) }
);

export type AddOrderMutationVariables = Exact<{
  cartSubmissionInput: CartSubmissionInput;
}>;


export type AddOrderMutation = (
  { __typename?: 'Mutation' }
  & { addOrder: (
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'status'>
  ) }
);

export type AddPaymentCardMutationVariables = Exact<{
  paymentCardInput: PaymentCardInput;
}>;


export type AddPaymentCardMutation = (
  { __typename?: 'Mutation' }
  & { addPaymentCard: (
    { __typename?: 'PaymentCard' }
    & Pick<PaymentCard, 'id' | 'cardToken' | 'cardAccount' | 'cardType' | 'cardholderName' | 'cardNickname' | 'cardExpirationDate' | 'isPrimary'>
  ) }
);

export type AddPetMutationVariables = Exact<{
  petInput: PetInput;
}>;


export type AddPetMutation = (
  { __typename?: 'Mutation' }
  & { addPet?: Maybe<(
    { __typename?: 'Pet' }
    & Pick<Pet, 'id'>
  )> }
);

export type AddRelationContactMutationVariables = Exact<{
  accountId: Scalars['ID'];
  relationContactInput: RelationContactInput;
}>;


export type AddRelationContactMutation = (
  { __typename?: 'Mutation' }
  & { addRelationContact?: Maybe<(
    { __typename?: 'RelationContact' }
    & Pick<RelationContact, 'id' | 'firstName' | 'lastName' | 'isEmergencyContact' | 'isRelated' | 'relationship'>
    & { phones?: Maybe<Array<(
      { __typename?: 'ContactPhone' }
      & Pick<ContactPhone, 'id' | 'phoneNumber' | 'country' | 'countryCallingCode' | 'type'>
    )>> }
  )> }
);

export type AddReservationRequestMutationVariables = Exact<{
  reservationInput: ReservationRequestInput;
}>;


export type AddReservationRequestMutation = (
  { __typename?: 'Mutation' }
  & { addReservationRequest: (
    { __typename?: 'Booking' }
    & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status'>
    & { pets?: Maybe<Array<Maybe<(
      { __typename?: 'Pet' }
      & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
    )>>>, franchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
    )>, items?: Maybe<Array<Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
      & { type: (
        { __typename?: 'ItemType' }
        & Pick<ItemType, 'id' | 'label' | 'active'>
      ), category: (
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
      ) }
    )>>> }
  ) }
);

export type CreateEmbeddedSignatureRequestWithTemplateMutationVariables = Exact<{
  termPolicyFormId: Scalars['ID'];
  embeddedInput: EmbeddedSignatureRequestWithTemplateInput;
}>;


export type CreateEmbeddedSignatureRequestWithTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createEmbeddedSignatureRequestWithTemplate: (
    { __typename?: 'SignatureRequest' }
    & Pick<SignatureRequest, 'testMode' | 'signatureRequestId' | 'requesterEmailAddress' | 'title' | 'originalTitle' | 'subject' | 'message' | 'createdAt' | 'isComplete' | 'isDeclined' | 'hasError' | 'finalCopyUri' | 'filesUrl' | 'signingUrl' | 'detailsUrl' | 'signingRedirectUrl' | 'embeddedSignUrl' | 'warningMsg' | 'warningName'>
    & { customFields?: Maybe<Array<(
      { __typename?: 'CustomField' }
      & Pick<CustomField, 'name' | 'type' | 'value' | 'required' | 'apiId' | 'editor'>
    )>>, responseData?: Maybe<Array<(
      { __typename?: 'FormField' }
      & Pick<FormField, 'apiId' | 'signatureId' | 'name' | 'value' | 'required' | 'type'>
    )>>, signatures?: Maybe<Array<(
      { __typename?: 'Signature' }
      & Pick<Signature, 'signedAt' | 'signerName' | 'signerRole' | 'signatureId' | 'signerEmailAddress' | 'order' | 'statusCode' | 'declineReason' | 'lastViewedAt' | 'lastRemindedAt' | 'hasPin' | 'reassignedBy' | 'reassignmentReason' | 'error'>
    )>> }
  ) }
);

export type DeletePaymentCardMutationVariables = Exact<{
  paymentCardId: Scalars['ID'];
}>;


export type DeletePaymentCardMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deletePaymentCard'>
);

export type DeleteRelationContactMutationVariables = Exact<{
  accountId: Scalars['ID'];
  relationContactId: Scalars['ID'];
}>;


export type DeleteRelationContactMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteRelationContact'>
);

export type PayWithCreditCardMutationVariables = Exact<{
  orderId: Scalars['ID'];
  remittancePayment: RemittancePaymentInput;
}>;


export type PayWithCreditCardMutation = (
  { __typename?: 'Mutation' }
  & { payWithCreditCard?: Maybe<Array<(
    { __typename?: 'OrderPayment' }
    & Pick<OrderPayment, 'usdAmount' | 'localAmount'>
    & { order: (
      { __typename?: 'Order' }
      & Pick<Order, 'id' | 'status'>
    ), payment: (
      { __typename?: 'Payment' }
      & Pick<Payment, 'id'>
    ) }
  )>> }
);

export type RemovePetMutationVariables = Exact<{
  petId: Scalars['ID'];
  petRemoval: PetRemovalInput;
}>;


export type RemovePetMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removePet'>
);

export type UpdateAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
  accountInput: AccountInput;
  forRegistration: Scalars['Boolean'];
}>;


export type UpdateAccountMutation = (
  { __typename?: 'Mutation' }
  & { updateAccount?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'firstName' | 'lastName' | 'email' | 'country' | 'address1' | 'address2' | 'city' | 'stateProvince' | 'postalCode'>
    & { preferredFranchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id'>
    )>, phones?: Maybe<Array<(
      { __typename?: 'AccountPhone' }
      & Pick<AccountPhone, 'id' | 'phoneNumber'>
      & { geoCountry?: Maybe<(
        { __typename?: 'GeoCountry' }
        & Pick<GeoCountry, 'id' | 'countryCallingCode'>
      )>, phoneType?: Maybe<(
        { __typename?: 'PhoneType' }
        & Pick<PhoneType, 'id' | 'type'>
      )> }
    )>> }
  )> }
);

export type UpdatePaymentCardMutationVariables = Exact<{
  paymentCardId: Scalars['ID'];
  paymentCardInput: PaymentCardInput;
}>;


export type UpdatePaymentCardMutation = (
  { __typename?: 'Mutation' }
  & { updatePaymentCard: (
    { __typename?: 'PaymentCard' }
    & Pick<PaymentCard, 'id' | 'cardToken' | 'cardAccount' | 'cardType' | 'cardholderName' | 'cardNickname' | 'cardExpirationDate' | 'isPrimary'>
  ) }
);

export type UpdatePetMutationVariables = Exact<{
  petId: Scalars['ID'];
  petInput: PetInput;
}>;


export type UpdatePetMutation = (
  { __typename?: 'Mutation' }
  & { updatePet?: Maybe<(
    { __typename?: 'Pet' }
    & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName' | 'dateOfBirth' | 'gender' | 'spayNeutered' | 'statusId' | 'active' | 'isTreat'>
    & { breeds?: Maybe<Array<(
      { __typename?: 'PetBreed' }
      & Pick<PetBreed, 'isPrimary'>
      & { breed: (
        { __typename?: 'Breed' }
        & Pick<Breed, 'id' | 'label' | 'active'>
      ) }
    )>>, colors?: Maybe<Array<(
      { __typename?: 'PetColor' }
      & Pick<PetColor, 'isPrimary'>
      & { color: (
        { __typename?: 'Color' }
        & Pick<Color, 'id' | 'label' | 'active'>
      ) }
    )>>, weight?: Maybe<(
      { __typename?: 'PetWeight' }
      & Pick<PetWeight, 'id' | 'franchiseId' | 'weight'>
    )>, vets?: Maybe<Array<(
      { __typename?: 'PetVet' }
      & Pick<PetVet, 'isPrimary'>
      & { vet: (
        { __typename?: 'Vet' }
        & Pick<Vet, 'id' | 'practiceName' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'email' | 'distance' | 'latitude' | 'longitude'>
        & { phones?: Maybe<Array<(
          { __typename?: 'VetPhone' }
          & Pick<VetPhone, 'id' | 'phoneNumber' | 'countryCallingCode' | 'type'>
        )>> }
      ) }
    )>>, vaccines?: Maybe<Array<(
      { __typename?: 'PetVaccine' }
      & Pick<PetVaccine, 'expiresOn' | 'memo' | 'vaccinationStatus'>
      & { vaccine: (
        { __typename?: 'Vaccine' }
        & Pick<Vaccine, 'id' | 'name' | 'required' | 'active' | 'notes'>
      ) }
    )>>, allergies?: Maybe<Array<(
      { __typename?: 'Allergy' }
      & Pick<Allergy, 'id' | 'attributeId' | 'name' | 'description'>
    )>>, feedings?: Maybe<Array<(
      { __typename?: 'Feeding' }
      & Pick<Feeding, 'id' | 'attributeId' | 'name' | 'isBreakfast' | 'isDinner' | 'quantity' | 'details'>
    )>>, medications?: Maybe<Array<(
      { __typename?: 'Medication' }
      & Pick<Medication, 'id' | 'attributeId' | 'name' | 'isMorning' | 'isAfternoon' | 'dosage' | 'notes'>
    )>>, camperReleases?: Maybe<Array<(
      { __typename?: 'CamperRelease' }
      & Pick<CamperRelease, 'id'>
    )>> }
  )> }
);

export type UpdatePreferredLocationMutationVariables = Exact<{
  accountId: Scalars['ID'];
  locationId: Scalars['ID'];
}>;


export type UpdatePreferredLocationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updatePreferredLocation'>
);

export type UpdateRelationContactMutationVariables = Exact<{
  accountId: Scalars['ID'];
  relationContactId: Scalars['ID'];
  relationContactInput: RelationContactInput;
}>;


export type UpdateRelationContactMutation = (
  { __typename?: 'Mutation' }
  & { updateRelationContact?: Maybe<(
    { __typename?: 'RelationContact' }
    & Pick<RelationContact, 'id' | 'firstName' | 'lastName' | 'isEmergencyContact' | 'isRelated' | 'relationship'>
    & { phones?: Maybe<Array<(
      { __typename?: 'ContactPhone' }
      & Pick<ContactPhone, 'id' | 'phoneNumber' | 'country' | 'countryCallingCode' | 'type'>
    )>> }
  )> }
);

export type CreateIFrameHashQueryVariables = Exact<{
  locationId: Scalars['ID'];
  parametersInput: TranSafeIFrameParametersInput;
}>;


export type CreateIFrameHashQuery = (
  { __typename?: 'Query' }
  & { createIFrameHash: (
    { __typename?: 'TranSafeIFrameHash' }
    & Pick<TranSafeIFrameHash, 'iFrameAttributes' | 'hash'>
  ) }
);

export type GetUserFirstNameQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetUserFirstNameQuery = (
  { __typename?: 'Query' }
  & { getAccount?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'firstName'>
  )> }
);

export type GetUserLastNameQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetUserLastNameQuery = (
  { __typename?: 'Query' }
  & { getAccount?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'lastName'>
  )> }
);

export type GetAccountPhonesIdQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetAccountPhonesIdQuery = (
  { __typename?: 'Query' }
  & { getAccount?: Maybe<(
    { __typename?: 'Account' }
    & { phones?: Maybe<Array<(
      { __typename?: 'AccountPhone' }
      & Pick<AccountPhone, 'id'>
    )>> }
  )> }
);

export type GetPreferredLocationQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetPreferredLocationQuery = (
  { __typename?: 'Query' }
  & { getPreferredLocation?: Maybe<(
    { __typename?: 'Franchise' }
    & Pick<Franchise, 'id' | 'code' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'email' | 'telephone' | 'tax' | 'websiteUrl' | 'homeBuddiesUrl' | 'hasDefaultTipItem' | 'creditCardProcessingEnabled'>
    & { merchant?: Maybe<(
      { __typename?: 'FranchiseMerchant' }
      & Pick<FranchiseMerchant, 'id' | 'merchTippercent'>
    )>, hoursOfOperation?: Maybe<(
      { __typename?: 'HoursOfOperation' }
      & Pick<HoursOfOperation, 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>
    )> }
  )> }
);

export type GetAccountDetailsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetAccountDetailsQuery = (
  { __typename?: 'Query' }
  & { getAccount?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'firstName' | 'lastName' | 'email' | 'country' | 'address1' | 'address2' | 'city' | 'stateProvince' | 'postalCode'>
    & { phones?: Maybe<Array<(
      { __typename?: 'AccountPhone' }
      & Pick<AccountPhone, 'id' | 'phoneNumber'>
      & { geoCountry?: Maybe<(
        { __typename?: 'GeoCountry' }
        & Pick<GeoCountry, 'id' | 'countryCallingCode'>
      )>, phoneType?: Maybe<(
        { __typename?: 'PhoneType' }
        & Pick<PhoneType, 'id' | 'type'>
      )> }
    )>> }
  )> }
);

export type GetCommPrefQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetCommPrefQuery = (
  { __typename?: 'Query' }
  & { getAccount?: Maybe<(
    { __typename?: 'Account' }
    & Pick<Account, 'marketingSmsOptIn' | 'marketingEmailOptIn'>
  )> }
);

export type GetAccountIdQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetAccountIdQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getAccountId'>
);

export type GetAccountTermPolicyFormsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetAccountTermPolicyFormsQuery = (
  { __typename?: 'Query' }
  & { getAccountTermPolicyForms?: Maybe<Array<(
    { __typename?: 'AccountTermPolicyForm' }
    & Pick<AccountTermPolicyForm, 'id' | 'documentId' | 'dateSigned'>
    & { termPolicyForm: (
      { __typename?: 'TermPolicyForm' }
      & Pick<TermPolicyForm, 'id' | 'version' | 'templateId'>
      & { geoCountry?: Maybe<(
        { __typename?: 'GeoCountry' }
        & Pick<GeoCountry, 'id' | 'countryIso' | 'name' | 'countryCallingCode'>
      )> }
    ) }
  )>> }
);

export type GetAvailableItemsQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;


export type GetAvailableItemsQuery = (
  { __typename?: 'Query' }
  & { getAvailableItems?: Maybe<Array<(
    { __typename?: 'Item' }
    & Pick<Item, 'id' | 'displayName' | 'label' | 'description' | 'code' | 'price' | 'isPrimary' | 'taxable'>
    & { type: (
      { __typename?: 'ItemType' }
      & Pick<ItemType, 'id' | 'label' | 'active'>
    ), category: (
      { __typename?: 'ItemCategory' }
      & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
    ), franchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id' | 'code' | 'territory' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'tax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl' | 'homeBuddiesUrl'>
    )>, items?: Maybe<Array<(
      { __typename?: 'PackageItem' }
      & Pick<PackageItem, 'quantity'>
      & { item: (
        { __typename?: 'Item' }
        & Pick<Item, 'price' | 'displayName' | 'taxable'>
      ) }
    )>> }
  )>> }
);

export type GetBreedsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBreedsQuery = (
  { __typename?: 'Query' }
  & { getBreeds?: Maybe<Array<(
    { __typename?: 'Breed' }
    & Pick<Breed, 'id' | 'label' | 'active'>
  )>> }
);

export type GetCamperCampingQuizAnswerQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetCamperCampingQuizAnswerQuery = (
  { __typename?: 'Query' }
  & { getCamperCampingQuizAnswer?: Maybe<(
    { __typename?: 'CamperCampingQuizAnswer' }
    & Pick<CamperCampingQuizAnswer, 'choices'>
  )> }
);

export type GetCamperCampingQuizQuestionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCamperCampingQuizQuestionQuery = (
  { __typename?: 'Query' }
  & { getCamperCampingQuizQuestion: (
    { __typename?: 'CamperCampingQuizQuestion' }
    & { options?: Maybe<Array<(
      { __typename?: 'CamperCampingQuizQuestionOption' }
      & Pick<CamperCampingQuizQuestionOption, 'id' | 'name'>
    )>> }
  ) }
);

export type GetColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetColorsQuery = (
  { __typename?: 'Query' }
  & { getColors?: Maybe<Array<(
    { __typename?: 'Color' }
    & Pick<Color, 'id' | 'label' | 'active'>
  )>> }
);

export type GetLocationQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;


export type GetLocationQuery = (
  { __typename?: 'Query' }
  & { getLocation?: Maybe<(
    { __typename?: 'Franchise' }
    & Pick<Franchise, 'id' | 'code' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'email' | 'telephone' | 'tax' | 'websiteUrl' | 'homeBuddiesUrl' | 'hasDefaultTipItem' | 'creditCardProcessingEnabled'>
    & { merchant?: Maybe<(
      { __typename?: 'FranchiseMerchant' }
      & Pick<FranchiseMerchant, 'id' | 'merchTippercent'>
    )>, hoursOfOperation?: Maybe<(
      { __typename?: 'HoursOfOperation' }
      & Pick<HoursOfOperation, 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>
    )> }
  )> }
);

export type GetMarketingTilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketingTilesQuery = (
  { __typename?: 'Query' }
  & { getMarketingTiles?: Maybe<Array<(
    { __typename?: 'MarketingTile' }
    & Pick<MarketingTile, 'id' | 'imagePath' | 'altText'>
  )>> }
);

export type GetMedicationsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
}>;


export type GetMedicationsQuery = (
  { __typename?: 'Query' }
  & { getMedications?: Maybe<Array<(
    { __typename?: 'Attribute' }
    & Pick<Attribute, 'id' | 'typeId' | 'subTypeId' | 'name' | 'description'>
  )>> }
);

export type GetNearestFranchisesQueryVariables = Exact<{
  code: Scalars['String'];
  radius: Scalars['Int'];
}>;


export type GetNearestFranchisesQuery = (
  { __typename?: 'Query' }
  & { getNearestFranchises?: Maybe<Array<(
    { __typename?: 'FranchiseWithDistance' }
    & Pick<FranchiseWithDistance, 'id' | 'code' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'telephone' | 'tax' | 'distanceInMi' | 'homeBuddiesUrl' | 'hasDefaultTipItem' | 'creditCardProcessingEnabled'>
    & { merchant?: Maybe<(
      { __typename?: 'FranchiseMerchant' }
      & Pick<FranchiseMerchant, 'id' | 'merchTippercent'>
    )> }
  )>> }
);

export type GetNearestVetsQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetNearestVetsQuery = (
  { __typename?: 'Query' }
  & { getNearestVets?: Maybe<Array<(
    { __typename?: 'VetWithDistance' }
    & Pick<VetWithDistance, 'id' | 'practiceName' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'email' | 'latitude' | 'longitude' | 'distanceInMi' | 'distanceInKm'>
    & { phones?: Maybe<Array<(
      { __typename?: 'VetPhone' }
      & Pick<VetPhone, 'phoneNumber' | 'country' | 'countryCallingCode' | 'type'>
    )>> }
  )>> }
);

export type GetPaymentCardQueryVariables = Exact<{
  paymentCardId: Scalars['ID'];
}>;


export type GetPaymentCardQuery = (
  { __typename?: 'Query' }
  & { getPaymentCard?: Maybe<(
    { __typename?: 'PaymentCard' }
    & Pick<PaymentCard, 'id' | 'cardToken' | 'cardAccount' | 'cardType' | 'cardholderName' | 'cardNickname' | 'cardExpirationDate' | 'isPrimary'>
  )> }
);

export type GetPaymentCardsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetPaymentCardsQuery = (
  { __typename?: 'Query' }
  & { getPaymentCards?: Maybe<Array<(
    { __typename?: 'PaymentCard' }
    & Pick<PaymentCard, 'id' | 'cardToken' | 'cardAccount' | 'cardType' | 'cardholderName' | 'cardNickname' | 'cardExpirationDate' | 'isPrimary'>
  )>> }
);

export type GetPetQueryVariables = Exact<{
  petId: Scalars['ID'];
}>;


export type GetPetQuery = (
  { __typename?: 'Query' }
  & { getPet?: Maybe<(
    { __typename?: 'Pet' }
    & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName' | 'dateOfBirth' | 'gender' | 'statusId' | 'active' | 'isTreat' | 'spayNeutered'>
    & { breeds?: Maybe<Array<(
      { __typename?: 'PetBreed' }
      & Pick<PetBreed, 'isPrimary'>
      & { breed: (
        { __typename?: 'Breed' }
        & Pick<Breed, 'id' | 'label' | 'active'>
      ) }
    )>>, colors?: Maybe<Array<(
      { __typename?: 'PetColor' }
      & Pick<PetColor, 'isPrimary'>
      & { color: (
        { __typename?: 'Color' }
        & Pick<Color, 'id' | 'label' | 'active'>
      ) }
    )>>, weight?: Maybe<(
      { __typename?: 'PetWeight' }
      & Pick<PetWeight, 'id' | 'franchiseId' | 'weight'>
    )>, vets?: Maybe<Array<(
      { __typename?: 'PetVet' }
      & Pick<PetVet, 'isPrimary'>
      & { vet: (
        { __typename?: 'Vet' }
        & Pick<Vet, 'id' | 'practiceName' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'email' | 'distance' | 'latitude' | 'longitude'>
        & { phones?: Maybe<Array<(
          { __typename?: 'VetPhone' }
          & Pick<VetPhone, 'id' | 'phoneNumber' | 'countryCallingCode' | 'type'>
        )>> }
      ) }
    )>>, vaccines?: Maybe<Array<(
      { __typename?: 'PetVaccine' }
      & Pick<PetVaccine, 'expiresOn' | 'memo' | 'vaccinationStatus'>
      & { vaccine: (
        { __typename?: 'Vaccine' }
        & Pick<Vaccine, 'id' | 'name' | 'required' | 'active' | 'notes'>
      ) }
    )>>, allergies?: Maybe<Array<(
      { __typename?: 'Allergy' }
      & Pick<Allergy, 'id' | 'attributeId' | 'name' | 'description'>
    )>>, feedings?: Maybe<Array<(
      { __typename?: 'Feeding' }
      & Pick<Feeding, 'id' | 'attributeId' | 'name' | 'isBreakfast' | 'isDinner' | 'quantity' | 'details'>
    )>>, medications?: Maybe<Array<(
      { __typename?: 'Medication' }
      & Pick<Medication, 'id' | 'attributeId' | 'name' | 'isMorning' | 'isAfternoon' | 'dosage' | 'notes'>
    )>>, camperReleases?: Maybe<Array<(
      { __typename?: 'CamperRelease' }
      & Pick<CamperRelease, 'id'>
    )>> }
  )> }
);

export type GetPetsWithStatusQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetPetsWithStatusQuery = (
  { __typename?: 'Query' }
  & { getPetsWithStatus?: Maybe<Array<(
    { __typename?: 'PetWithStatus' }
    & Pick<PetWithStatus, 'id' | 'active' | 'firstName' | 'lastName' | 'nickName' | 'statusId' | 'numberOfUnverifiedPetVaccinations'>
    & { weight?: Maybe<(
      { __typename?: 'PetWeight' }
      & Pick<PetWeight, 'id' | 'franchiseId' | 'weight'>
    )>, colors?: Maybe<Array<(
      { __typename?: 'PetColor' }
      & Pick<PetColor, 'isPrimary'>
      & { color: (
        { __typename?: 'Color' }
        & Pick<Color, 'id' | 'label' | 'active'>
      ) }
    )>>, breeds?: Maybe<Array<(
      { __typename?: 'PetBreed' }
      & Pick<PetBreed, 'isPrimary'>
      & { breed: (
        { __typename?: 'Breed' }
        & Pick<Breed, 'id' | 'label' | 'active'>
      ) }
    )>>, upcomingBookings?: Maybe<Array<Maybe<(
      { __typename?: 'Booking' }
      & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status'>
      & { pets?: Maybe<Array<Maybe<(
        { __typename?: 'Pet' }
        & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
      )>>>, franchise?: Maybe<(
        { __typename?: 'Franchise' }
        & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
      )>, items?: Maybe<Array<Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
        & { type: (
          { __typename?: 'ItemType' }
          & Pick<ItemType, 'id' | 'label' | 'active'>
        ), category: (
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
        ) }
      )>>> }
    )>>>, waitlistBookings?: Maybe<Array<Maybe<(
      { __typename?: 'Booking' }
      & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status'>
      & { pets?: Maybe<Array<Maybe<(
        { __typename?: 'Pet' }
        & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
      )>>>, franchise?: Maybe<(
        { __typename?: 'Franchise' }
        & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
      )>, items?: Maybe<Array<Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
        & { type: (
          { __typename?: 'ItemType' }
          & Pick<ItemType, 'id' | 'label' | 'active'>
        ), category: (
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
        ) }
      )>>> }
    )>>>, reservationRequests?: Maybe<Array<Maybe<(
      { __typename?: 'Booking' }
      & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status'>
      & { pets?: Maybe<Array<Maybe<(
        { __typename?: 'Pet' }
        & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
      )>>>, franchise?: Maybe<(
        { __typename?: 'Franchise' }
        & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
      )>, items?: Maybe<Array<Maybe<(
        { __typename?: 'Item' }
        & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
        & { type: (
          { __typename?: 'ItemType' }
          & Pick<ItemType, 'id' | 'label' | 'active'>
        ), category: (
          { __typename?: 'ItemCategory' }
          & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
        ) }
      )>>> }
    )>>>, vaccines?: Maybe<Array<(
      { __typename?: 'PetVaccine' }
      & Pick<PetVaccine, 'vaccinationStatus' | 'expiresOn' | 'memo'>
      & { vaccine: (
        { __typename?: 'Vaccine' }
        & Pick<Vaccine, 'id' | 'name' | 'active' | 'required' | 'notes'>
      ) }
    )>>, vets?: Maybe<Array<(
      { __typename?: 'PetVet' }
      & { vet: (
        { __typename?: 'Vet' }
        & Pick<Vet, 'id'>
      ) }
    )>> }
  )>> }
);

export type GetRelationContactsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetRelationContactsQuery = (
  { __typename?: 'Query' }
  & { getRelationContacts?: Maybe<Array<(
    { __typename?: 'RelationContact' }
    & Pick<RelationContact, 'id' | 'firstName' | 'lastName' | 'email' | 'country' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'isRelated' | 'relationship' | 'isEmergencyContact'>
    & { phones?: Maybe<Array<(
      { __typename?: 'ContactPhone' }
      & Pick<ContactPhone, 'id' | 'countryCallingCode' | 'phoneNumber' | 'type'>
    )>> }
  )>> }
);

export type GetRelationContactQueryVariables = Exact<{
  accountId: Scalars['ID'];
  relationContactId: Scalars['ID'];
}>;


export type GetRelationContactQuery = (
  { __typename?: 'Query' }
  & { getRelationContact?: Maybe<(
    { __typename?: 'RelationContact' }
    & Pick<RelationContact, 'id' | 'firstName' | 'lastName' | 'email' | 'country' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'isRelated' | 'relationship' | 'isEmergencyContact'>
    & { phones?: Maybe<Array<(
      { __typename?: 'ContactPhone' }
      & Pick<ContactPhone, 'id' | 'countryCallingCode' | 'phoneNumber' | 'type'>
    )>> }
  )> }
);

export type GetTermPolicyFormsQueryVariables = Exact<{
  franchiseId?: Maybe<Scalars['ID']>;
}>;


export type GetTermPolicyFormsQuery = (
  { __typename?: 'Query' }
  & { getTermPolicyForms?: Maybe<Array<(
    { __typename?: 'TermPolicyForm' }
    & Pick<TermPolicyForm, 'id' | 'version' | 'templateId'>
    & { geoCountry?: Maybe<(
      { __typename?: 'GeoCountry' }
      & Pick<GeoCountry, 'id' | 'countryIso' | 'name' | 'countryCallingCode'>
    )> }
  )>> }
);

export type GetReservationRequestQueryVariables = Exact<{
  reservationRequestId: Scalars['ID'];
}>;


export type GetReservationRequestQuery = (
  { __typename?: 'Query' }
  & { getReservationRequest?: Maybe<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status'>
    & { pets?: Maybe<Array<Maybe<(
      { __typename?: 'Pet' }
      & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
    )>>>, franchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
    )>, items?: Maybe<Array<Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
      & { type: (
        { __typename?: 'ItemType' }
        & Pick<ItemType, 'id' | 'label' | 'active'>
      ), category: (
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
      ) }
    )>>> }
  )> }
);

export type GetReservationRequestsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetReservationRequestsQuery = (
  { __typename?: 'Query' }
  & { getReservationRequests?: Maybe<Array<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status'>
    & { pets?: Maybe<Array<Maybe<(
      { __typename?: 'Pet' }
      & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
    )>>>, franchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
    )>, items?: Maybe<Array<Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
      & { type: (
        { __typename?: 'ItemType' }
        & Pick<ItemType, 'id' | 'label' | 'active'>
      ), category: (
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
      ) }
    )>>> }
  )>> }
);

export type GetSignatureRequestQueryVariables = Exact<{
  documentId: Scalars['String'];
}>;


export type GetSignatureRequestQuery = (
  { __typename?: 'Query' }
  & { getSignatureRequest?: Maybe<(
    { __typename?: 'SignatureRequest' }
    & Pick<SignatureRequest, 'testMode' | 'signatureRequestId' | 'requesterEmailAddress' | 'title' | 'originalTitle' | 'subject' | 'message' | 'createdAt' | 'isComplete' | 'isDeclined' | 'hasError' | 'finalCopyUri' | 'filesUrl' | 'signingUrl' | 'detailsUrl' | 'signingRedirectUrl' | 'embeddedSignUrl' | 'warningMsg' | 'warningName'>
    & { customFields?: Maybe<Array<(
      { __typename?: 'CustomField' }
      & Pick<CustomField, 'name' | 'type' | 'value' | 'required' | 'apiId' | 'editor'>
    )>>, responseData?: Maybe<Array<(
      { __typename?: 'FormField' }
      & Pick<FormField, 'apiId' | 'signatureId' | 'name' | 'value' | 'required' | 'type'>
    )>>, signatures?: Maybe<Array<(
      { __typename?: 'Signature' }
      & Pick<Signature, 'signedAt' | 'signerName' | 'signerRole' | 'signatureId' | 'signerEmailAddress' | 'order' | 'statusCode' | 'declineReason' | 'lastViewedAt' | 'lastRemindedAt' | 'hasPin' | 'reassignedBy' | 'reassignmentReason' | 'error'>
    )>> }
  )> }
);

export type GetSignatureRequestFilesQueryVariables = Exact<{
  accountTermPolicyFormId: Scalars['ID'];
}>;


export type GetSignatureRequestFilesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getSignatureRequestFiles'>
);

export type GetUpcomingBookingQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type GetUpcomingBookingQuery = (
  { __typename?: 'Query' }
  & { getUpcomingBooking?: Maybe<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status' | 'declineReason'>
    & { pets?: Maybe<Array<Maybe<(
      { __typename?: 'Pet' }
      & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
    )>>>, items?: Maybe<Array<Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
      & { type: (
        { __typename?: 'ItemType' }
        & Pick<ItemType, 'id' | 'label' | 'active'>
      ), category: (
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
      ) }
    )>>>, franchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
    )> }
  )> }
);

export type GetUpcomingBookingsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetUpcomingBookingsQuery = (
  { __typename?: 'Query' }
  & { getUpcomingBookings?: Maybe<Array<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status' | 'declineReason'>
    & { pets?: Maybe<Array<Maybe<(
      { __typename?: 'Pet' }
      & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
    )>>>, franchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
    )>, items?: Maybe<Array<Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
      & { type: (
        { __typename?: 'ItemType' }
        & Pick<ItemType, 'id' | 'label' | 'active'>
      ), category: (
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
      ) }
    )>>> }
  )>> }
);

export type GetVisitedLocationsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetVisitedLocationsQuery = (
  { __typename?: 'Query' }
  & { getVisitedLocations?: Maybe<Array<(
    { __typename?: 'Franchise' }
    & Pick<Franchise, 'id' | 'code' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'email' | 'telephone' | 'tax' | 'websiteUrl' | 'homeBuddiesUrl' | 'hasDefaultTipItem' | 'creditCardProcessingEnabled'>
    & { merchant?: Maybe<(
      { __typename?: 'FranchiseMerchant' }
      & Pick<FranchiseMerchant, 'id' | 'merchTippercent'>
    )>, hoursOfOperation?: Maybe<(
      { __typename?: 'HoursOfOperation' }
      & Pick<HoursOfOperation, 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'>
    )> }
  )>> }
);

export type GetWaitlistBookingQueryVariables = Exact<{
  waitlistBookingId: Scalars['ID'];
}>;


export type GetWaitlistBookingQuery = (
  { __typename?: 'Query' }
  & { getWaitlistBooking?: Maybe<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status'>
    & { pets?: Maybe<Array<Maybe<(
      { __typename?: 'Pet' }
      & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
    )>>>, franchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
    )>, items?: Maybe<Array<Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
      & { type: (
        { __typename?: 'ItemType' }
        & Pick<ItemType, 'id' | 'label' | 'active'>
      ), category: (
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
      ) }
    )>>> }
  )> }
);

export type GetWaitlistBookingsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type GetWaitlistBookingsQuery = (
  { __typename?: 'Query' }
  & { getWaitlistBookings?: Maybe<Array<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'id' | 'title' | 'type' | 'categories' | 'startDate' | 'endDate' | 'status'>
    & { pets?: Maybe<Array<Maybe<(
      { __typename?: 'Pet' }
      & Pick<Pet, 'id' | 'firstName' | 'nickName' | 'lastName'>
    )>>>, franchise?: Maybe<(
      { __typename?: 'Franchise' }
      & Pick<Franchise, 'id' | 'name' | 'address1' | 'address2' | 'city' | 'state' | 'zipcode' | 'country' | 'telephone' | 'fax' | 'latitude' | 'longitude' | 'email' | 'websiteUrl'>
    )>, items?: Maybe<Array<Maybe<(
      { __typename?: 'Item' }
      & Pick<Item, 'id' | 'label' | 'displayName' | 'description' | 'code' | 'price'>
      & { type: (
        { __typename?: 'ItemType' }
        & Pick<ItemType, 'id' | 'label' | 'active'>
      ), category: (
        { __typename?: 'ItemCategory' }
        & Pick<ItemCategory, 'id' | 'label' | 'parentId' | 'typeId' | 'active'>
      ) }
    )>>> }
  )>> }
);

export type HasExistingReservationsQueryVariables = Exact<{
  reservationService: ReservationServiceInput;
}>;


export type HasExistingReservationsQuery = (
  { __typename?: 'Query' }
  & { hasExistingReservations?: Maybe<Array<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'id'>
  )>> }
);

export type IsEmailExistQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsEmailExistQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isEmailExist'>
);

export const AddAccountDocument = gql`
    mutation addAccount($accountInput: AccountInput!) {
  addAccount(account: $accountInput) {
    firstName
    lastName
    email
    phones {
      phoneNumber
    }
    preferredFranchise {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddAccountGQL extends Apollo.Mutation<AddAccountMutation, AddAccountMutationVariables> {
    document = AddAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddAccountTermPolicyFormDocument = gql`
    mutation addAccountTermPolicyForm($accountTermPolicyForm: AccountTermPolicyFormInput!, $uploadSignedFileToS3: Boolean!) {
  addAccountTermPolicyForm(
    accountTermPolicyForm: $accountTermPolicyForm
    uploadSignedFileToS3: $uploadSignedFileToS3
  ) {
    id
    termPolicyForm {
      id
      version
      templateId
      geoCountry {
        id
        countryIso
        name
        countryCallingCode
      }
    }
    documentId
    dateSigned
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddAccountTermPolicyFormGQL extends Apollo.Mutation<AddAccountTermPolicyFormMutation, AddAccountTermPolicyFormMutationVariables> {
    document = AddAccountTermPolicyFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCamperCampingQuizAnswerDocument = gql`
    mutation addCamperCampingQuizAnswer($accountId: ID!, $answer: CamperCampingQuizAnswerInput!) {
  addCamperCampingQuizAnswer(accountId: $accountId, answer: $answer)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCamperCampingQuizAnswerGQL extends Apollo.Mutation<AddCamperCampingQuizAnswerMutation, AddCamperCampingQuizAnswerMutationVariables> {
    document = AddCamperCampingQuizAnswerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddInterviewRequestDocument = gql`
    mutation addInterviewRequest($interviewRequest: InterviewRequestInput!) {
  addInterviewRequest(interviewRequest: $interviewRequest) {
    id
    title
    type
    categories
    startDate
    endDate
    status
    pets {
      id
      firstName
      nickName
      lastName
    }
    franchise {
      id
      name
      address1
      address2
      city
      state
      zipcode
      country
      telephone
      fax
      latitude
      longitude
      email
      websiteUrl
    }
    items {
      id
      label
      displayName
      description
      code
      type {
        id
        label
        active
      }
      category {
        id
        label
        parentId
        typeId
        active
      }
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddInterviewRequestGQL extends Apollo.Mutation<AddInterviewRequestMutation, AddInterviewRequestMutationVariables> {
    document = AddInterviewRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddOrderDocument = gql`
    mutation addOrder($cartSubmissionInput: CartSubmissionInput!) {
  addOrder(cart: $cartSubmissionInput) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddOrderGQL extends Apollo.Mutation<AddOrderMutation, AddOrderMutationVariables> {
    document = AddOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddPaymentCardDocument = gql`
    mutation addPaymentCard($paymentCardInput: PaymentCardInput!) {
  addPaymentCard(paymentCard: $paymentCardInput) {
    id
    cardToken
    cardAccount
    cardType
    cardholderName
    cardNickname
    cardExpirationDate
    isPrimary
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddPaymentCardGQL extends Apollo.Mutation<AddPaymentCardMutation, AddPaymentCardMutationVariables> {
    document = AddPaymentCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddPetDocument = gql`
    mutation addPet($petInput: PetInput!) {
  addPet(pet: $petInput) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddPetGQL extends Apollo.Mutation<AddPetMutation, AddPetMutationVariables> {
    document = AddPetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddRelationContactDocument = gql`
    mutation addRelationContact($accountId: ID!, $relationContactInput: RelationContactInput!) {
  addRelationContact(
    accountId: $accountId
    relationContact: $relationContactInput
  ) {
    id
    firstName
    lastName
    phones {
      id
      phoneNumber
      country
      countryCallingCode
      type
    }
    isEmergencyContact
    isRelated
    relationship
    isEmergencyContact
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddRelationContactGQL extends Apollo.Mutation<AddRelationContactMutation, AddRelationContactMutationVariables> {
    document = AddRelationContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddReservationRequestDocument = gql`
    mutation addReservationRequest($reservationInput: ReservationRequestInput!) {
  addReservationRequest(reservationRequest: $reservationInput) {
    id
    title
    type
    categories
    startDate
    endDate
    status
    pets {
      id
      firstName
      nickName
      lastName
    }
    franchise {
      id
      name
      address1
      address2
      city
      state
      zipcode
      country
      telephone
      fax
      latitude
      longitude
      email
      websiteUrl
    }
    items {
      id
      label
      displayName
      description
      code
      type {
        id
        label
        active
      }
      category {
        id
        label
        parentId
        typeId
        active
      }
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddReservationRequestGQL extends Apollo.Mutation<AddReservationRequestMutation, AddReservationRequestMutationVariables> {
    document = AddReservationRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEmbeddedSignatureRequestWithTemplateDocument = gql`
    mutation createEmbeddedSignatureRequestWithTemplate($termPolicyFormId: ID!, $embeddedInput: EmbeddedSignatureRequestWithTemplateInput!) {
  createEmbeddedSignatureRequestWithTemplate(
    termPolicyFormId: $termPolicyFormId
    embeddedSignatureRequestWithTemplate: $embeddedInput
  ) {
    testMode
    signatureRequestId
    requesterEmailAddress
    title
    originalTitle
    subject
    message
    createdAt
    isComplete
    isDeclined
    hasError
    finalCopyUri
    filesUrl
    signingUrl
    detailsUrl
    signingRedirectUrl
    customFields {
      name
      type
      value
      required
      apiId
      editor
    }
    responseData {
      apiId
      signatureId
      name
      value
      required
      type
    }
    signatures {
      signedAt
      signerName
      signerRole
      signatureId
      signerEmailAddress
      signerRole
      order
      statusCode
      declineReason
      signedAt
      lastViewedAt
      lastRemindedAt
      hasPin
      reassignedBy
      reassignmentReason
      error
    }
    embeddedSignUrl
    warningMsg
    warningName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEmbeddedSignatureRequestWithTemplateGQL extends Apollo.Mutation<CreateEmbeddedSignatureRequestWithTemplateMutation, CreateEmbeddedSignatureRequestWithTemplateMutationVariables> {
    document = CreateEmbeddedSignatureRequestWithTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePaymentCardDocument = gql`
    mutation deletePaymentCard($paymentCardId: ID!) {
  deletePaymentCard(paymentCardId: $paymentCardId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePaymentCardGQL extends Apollo.Mutation<DeletePaymentCardMutation, DeletePaymentCardMutationVariables> {
    document = DeletePaymentCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRelationContactDocument = gql`
    mutation deleteRelationContact($accountId: ID!, $relationContactId: ID!) {
  deleteRelationContact(
    accountId: $accountId
    relationContactId: $relationContactId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRelationContactGQL extends Apollo.Mutation<DeleteRelationContactMutation, DeleteRelationContactMutationVariables> {
    document = DeleteRelationContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PayWithCreditCardDocument = gql`
    mutation payWithCreditCard($orderId: ID!, $remittancePayment: RemittancePaymentInput!) {
  payWithCreditCard(orderId: $orderId, remittancePayment: $remittancePayment) {
    order {
      id
      status
    }
    payment {
      id
    }
    usdAmount
    localAmount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PayWithCreditCardGQL extends Apollo.Mutation<PayWithCreditCardMutation, PayWithCreditCardMutationVariables> {
    document = PayWithCreditCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemovePetDocument = gql`
    mutation removePet($petId: ID!, $petRemoval: PetRemovalInput!) {
  removePet(petId: $petId, removal: $petRemoval)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemovePetGQL extends Apollo.Mutation<RemovePetMutation, RemovePetMutationVariables> {
    document = RemovePetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAccountDocument = gql`
    mutation updateAccount($accountId: ID!, $accountInput: AccountInput!, $forRegistration: Boolean!) {
  updateAccount(
    accountId: $accountId
    account: $accountInput
    forRegistration: $forRegistration
  ) {
    preferredFranchise {
      id
    }
    firstName
    lastName
    email
    phones {
      id
      geoCountry {
        id
        countryCallingCode
      }
      phoneNumber
      phoneType {
        id
        type
      }
    }
    country
    address1
    address2
    city
    stateProvince
    postalCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAccountGQL extends Apollo.Mutation<UpdateAccountMutation, UpdateAccountMutationVariables> {
    document = UpdateAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePaymentCardDocument = gql`
    mutation updatePaymentCard($paymentCardId: ID!, $paymentCardInput: PaymentCardInput!) {
  updatePaymentCard(paymentCardId: $paymentCardId, paymentCard: $paymentCardInput) {
    id
    cardToken
    cardAccount
    cardType
    cardholderName
    cardNickname
    cardExpirationDate
    isPrimary
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePaymentCardGQL extends Apollo.Mutation<UpdatePaymentCardMutation, UpdatePaymentCardMutationVariables> {
    document = UpdatePaymentCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePetDocument = gql`
    mutation updatePet($petId: ID!, $petInput: PetInput!) {
  updatePet(petId: $petId, pet: $petInput) {
    id
    firstName
    nickName
    lastName
    dateOfBirth
    gender
    spayNeutered
    statusId
    active
    isTreat
    breeds {
      breed {
        id
        label
        active
      }
      isPrimary
    }
    colors {
      color {
        id
        label
        active
      }
      isPrimary
    }
    weight {
      id
      franchiseId
      weight
    }
    vets {
      vet {
        id
        practiceName
        address1
        address2
        city
        state
        zipcode
        email
        phones {
          id
          phoneNumber
          countryCallingCode
          type
        }
        distance
        latitude
        longitude
      }
      isPrimary
    }
    vaccines {
      expiresOn
      memo
      vaccinationStatus
      vaccine {
        id
        name
        required
        active
        notes
      }
    }
    allergies {
      id
      attributeId
      name
      description
    }
    feedings {
      id
      attributeId
      name
      isBreakfast
      isDinner
      quantity
      details
    }
    medications {
      id
      attributeId
      name
      isMorning
      isAfternoon
      dosage
      notes
    }
    camperReleases {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePetGQL extends Apollo.Mutation<UpdatePetMutation, UpdatePetMutationVariables> {
    document = UpdatePetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePreferredLocationDocument = gql`
    mutation updatePreferredLocation($accountId: ID!, $locationId: ID!) {
  updatePreferredLocation(accountId: $accountId, locationId: $locationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePreferredLocationGQL extends Apollo.Mutation<UpdatePreferredLocationMutation, UpdatePreferredLocationMutationVariables> {
    document = UpdatePreferredLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRelationContactDocument = gql`
    mutation updateRelationContact($accountId: ID!, $relationContactId: ID!, $relationContactInput: RelationContactInput!) {
  updateRelationContact(
    accountId: $accountId
    relationContactId: $relationContactId
    relationContact: $relationContactInput
  ) {
    id
    firstName
    lastName
    phones {
      id
      phoneNumber
      country
      countryCallingCode
      type
    }
    isEmergencyContact
    isRelated
    relationship
    isEmergencyContact
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRelationContactGQL extends Apollo.Mutation<UpdateRelationContactMutation, UpdateRelationContactMutationVariables> {
    document = UpdateRelationContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIFrameHashDocument = gql`
    query createIFrameHash($locationId: ID!, $parametersInput: TranSafeIFrameParametersInput!) {
  createIFrameHash(locationId: $locationId, parameters: $parametersInput) {
    iFrameAttributes
    hash
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIFrameHashGQL extends Apollo.Query<CreateIFrameHashQuery, CreateIFrameHashQueryVariables> {
    document = CreateIFrameHashDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserFirstNameDocument = gql`
    query getUserFirstName($accountId: ID!) {
  getAccount(accountId: $accountId) {
    firstName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserFirstNameGQL extends Apollo.Query<GetUserFirstNameQuery, GetUserFirstNameQueryVariables> {
    document = GetUserFirstNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserLastNameDocument = gql`
    query getUserLastName($accountId: ID!) {
  getAccount(accountId: $accountId) {
    lastName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserLastNameGQL extends Apollo.Query<GetUserLastNameQuery, GetUserLastNameQueryVariables> {
    document = GetUserLastNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAccountPhonesIdDocument = gql`
    query getAccountPhonesId($accountId: ID!) {
  getAccount(accountId: $accountId) {
    phones {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountPhonesIdGQL extends Apollo.Query<GetAccountPhonesIdQuery, GetAccountPhonesIdQueryVariables> {
    document = GetAccountPhonesIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPreferredLocationDocument = gql`
    query getPreferredLocation($accountId: ID!) {
  getPreferredLocation(accountId: $accountId) {
    id
    code
    name
    address1
    address2
    city
    state
    zipcode
    country
    email
    telephone
    tax
    websiteUrl
    homeBuddiesUrl
    hasDefaultTipItem
    merchant {
      id
      merchTippercent
    }
    creditCardProcessingEnabled
    hoursOfOperation {
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPreferredLocationGQL extends Apollo.Query<GetPreferredLocationQuery, GetPreferredLocationQueryVariables> {
    document = GetPreferredLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAccountDetailsDocument = gql`
    query getAccountDetails($accountId: ID!) {
  getAccount(accountId: $accountId) {
    firstName
    lastName
    email
    phones {
      id
      geoCountry {
        id
        countryCallingCode
      }
      phoneNumber
      phoneType {
        id
        type
      }
    }
    country
    address1
    address2
    city
    stateProvince
    postalCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountDetailsGQL extends Apollo.Query<GetAccountDetailsQuery, GetAccountDetailsQueryVariables> {
    document = GetAccountDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCommPrefDocument = gql`
    query getCommPref($accountId: ID!) {
  getAccount(accountId: $accountId) {
    marketingSmsOptIn
    marketingEmailOptIn
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCommPrefGQL extends Apollo.Query<GetCommPrefQuery, GetCommPrefQueryVariables> {
    document = GetCommPrefDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAccountIdDocument = gql`
    query getAccountId($email: String!) {
  getAccountId(email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountIdGQL extends Apollo.Query<GetAccountIdQuery, GetAccountIdQueryVariables> {
    document = GetAccountIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAccountTermPolicyFormsDocument = gql`
    query getAccountTermPolicyForms($accountId: ID!) {
  getAccountTermPolicyForms(accountId: $accountId) {
    id
    termPolicyForm {
      id
      version
      templateId
      geoCountry {
        id
        countryIso
        name
        countryCallingCode
      }
    }
    documentId
    dateSigned
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountTermPolicyFormsGQL extends Apollo.Query<GetAccountTermPolicyFormsQuery, GetAccountTermPolicyFormsQueryVariables> {
    document = GetAccountTermPolicyFormsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAvailableItemsDocument = gql`
    query getAvailableItems($locationId: ID!) {
  getAvailableItems(locationId: $locationId) {
    id
    displayName
    label
    description
    code
    type {
      id
      label
      active
    }
    category {
      id
      label
      parentId
      typeId
      active
    }
    price
    isPrimary
    taxable
    franchise {
      id
      code
      territory
      name
      address1
      address2
      city
      state
      zipcode
      country
      telephone
      fax
      tax
      latitude
      longitude
      email
      websiteUrl
      homeBuddiesUrl
    }
    items {
      item {
        price
        displayName
        taxable
      }
      quantity
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAvailableItemsGQL extends Apollo.Query<GetAvailableItemsQuery, GetAvailableItemsQueryVariables> {
    document = GetAvailableItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBreedsDocument = gql`
    query getBreeds {
  getBreeds(page: 1, limit: 500, order: "asc") {
    id
    label
    active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBreedsGQL extends Apollo.Query<GetBreedsQuery, GetBreedsQueryVariables> {
    document = GetBreedsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCamperCampingQuizAnswerDocument = gql`
    query getCamperCampingQuizAnswer($accountId: ID!) {
  getCamperCampingQuizAnswer(accountId: $accountId) {
    choices
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCamperCampingQuizAnswerGQL extends Apollo.Query<GetCamperCampingQuizAnswerQuery, GetCamperCampingQuizAnswerQueryVariables> {
    document = GetCamperCampingQuizAnswerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCamperCampingQuizQuestionDocument = gql`
    query getCamperCampingQuizQuestion {
  getCamperCampingQuizQuestion {
    options {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCamperCampingQuizQuestionGQL extends Apollo.Query<GetCamperCampingQuizQuestionQuery, GetCamperCampingQuizQuestionQueryVariables> {
    document = GetCamperCampingQuizQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetColorsDocument = gql`
    query getColors {
  getColors(page: 1, limit: 500, order: "asc") {
    id
    label
    active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetColorsGQL extends Apollo.Query<GetColorsQuery, GetColorsQueryVariables> {
    document = GetColorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationDocument = gql`
    query getLocation($locationId: ID!) {
  getLocation(locationId: $locationId) {
    id
    code
    name
    address1
    address2
    city
    state
    zipcode
    country
    email
    telephone
    tax
    websiteUrl
    homeBuddiesUrl
    hasDefaultTipItem
    merchant {
      id
      merchTippercent
    }
    creditCardProcessingEnabled
    hoursOfOperation {
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationGQL extends Apollo.Query<GetLocationQuery, GetLocationQueryVariables> {
    document = GetLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMarketingTilesDocument = gql`
    query getMarketingTiles {
  getMarketingTiles {
    id
    imagePath
    altText
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMarketingTilesGQL extends Apollo.Query<GetMarketingTilesQuery, GetMarketingTilesQueryVariables> {
    document = GetMarketingTilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMedicationsDocument = gql`
    query getMedications($search: String) {
  getMedications(search: $search) {
    id
    typeId
    subTypeId
    name
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMedicationsGQL extends Apollo.Query<GetMedicationsQuery, GetMedicationsQueryVariables> {
    document = GetMedicationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNearestFranchisesDocument = gql`
    query getNearestFranchises($code: String!, $radius: Int!) {
  getNearestFranchises(postalCode: $code, radius: $radius, unit: MI) {
    id
    code
    name
    address1
    address2
    city
    state
    zipcode
    telephone
    tax
    distanceInMi
    homeBuddiesUrl
    hasDefaultTipItem
    creditCardProcessingEnabled
    merchant {
      id
      merchTippercent
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNearestFranchisesGQL extends Apollo.Query<GetNearestFranchisesQuery, GetNearestFranchisesQueryVariables> {
    document = GetNearestFranchisesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNearestVetsDocument = gql`
    query getNearestVets($code: String!) {
  getNearestVets(postalCode: $code, radius: 5, unit: MI) {
    id
    practiceName
    address1
    address2
    city
    state
    zipcode
    email
    phones {
      phoneNumber
      country
      countryCallingCode
      type
    }
    latitude
    longitude
    distanceInMi
    distanceInKm
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNearestVetsGQL extends Apollo.Query<GetNearestVetsQuery, GetNearestVetsQueryVariables> {
    document = GetNearestVetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaymentCardDocument = gql`
    query getPaymentCard($paymentCardId: ID!) {
  getPaymentCard(paymentCardId: $paymentCardId) {
    id
    cardToken
    cardAccount
    cardType
    cardholderName
    cardNickname
    cardExpirationDate
    isPrimary
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentCardGQL extends Apollo.Query<GetPaymentCardQuery, GetPaymentCardQueryVariables> {
    document = GetPaymentCardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaymentCardsDocument = gql`
    query getPaymentCards($accountId: ID!) {
  getPaymentCards(accountId: $accountId) {
    id
    cardToken
    cardAccount
    cardType
    cardholderName
    cardNickname
    cardExpirationDate
    isPrimary
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentCardsGQL extends Apollo.Query<GetPaymentCardsQuery, GetPaymentCardsQueryVariables> {
    document = GetPaymentCardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPetDocument = gql`
    query getPet($petId: ID!) {
  getPet(petId: $petId) {
    id
    firstName
    nickName
    lastName
    dateOfBirth
    gender
    statusId
    active
    isTreat
    spayNeutered
    breeds {
      breed {
        id
        label
        active
      }
      isPrimary
    }
    colors {
      color {
        id
        label
        active
      }
      isPrimary
    }
    weight {
      id
      franchiseId
      weight
    }
    vets {
      vet {
        id
        practiceName
        address1
        address2
        city
        state
        zipcode
        email
        phones {
          id
          phoneNumber
          countryCallingCode
          type
        }
        distance
        latitude
        longitude
      }
      isPrimary
    }
    vaccines {
      expiresOn
      memo
      vaccinationStatus
      vaccine {
        id
        name
        required
        active
        notes
      }
    }
    allergies {
      id
      attributeId
      name
      description
    }
    feedings {
      id
      attributeId
      name
      isBreakfast
      isDinner
      quantity
      details
    }
    medications {
      id
      attributeId
      name
      isMorning
      isAfternoon
      dosage
      notes
    }
    camperReleases {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPetGQL extends Apollo.Query<GetPetQuery, GetPetQueryVariables> {
    document = GetPetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPetsWithStatusDocument = gql`
    query getPetsWithStatus($accountId: ID!) {
  getPetsWithStatus(accountId: $accountId) {
    id
    active
    firstName
    lastName
    nickName
    statusId
    weight {
      id
      franchiseId
      weight
    }
    colors {
      color {
        id
        label
        active
      }
      isPrimary
    }
    breeds {
      breed {
        id
        label
        active
      }
      isPrimary
    }
    upcomingBookings {
      id
      title
      type
      categories
      startDate
      endDate
      status
      pets {
        id
        firstName
        nickName
        lastName
      }
      franchise {
        id
        name
        address1
        address2
        city
        state
        zipcode
        country
        telephone
        fax
        latitude
        longitude
        email
        websiteUrl
      }
      items {
        id
        label
        displayName
        description
        code
        type {
          id
          label
          active
        }
        category {
          id
          label
          parentId
          typeId
          active
        }
        price
      }
    }
    waitlistBookings {
      id
      title
      type
      categories
      startDate
      endDate
      status
      pets {
        id
        firstName
        nickName
        lastName
      }
      franchise {
        id
        name
        address1
        address2
        city
        state
        zipcode
        country
        telephone
        fax
        latitude
        longitude
        email
        websiteUrl
      }
      items {
        id
        label
        displayName
        description
        code
        type {
          id
          label
          active
        }
        category {
          id
          label
          parentId
          typeId
          active
        }
        price
      }
    }
    reservationRequests {
      id
      title
      type
      categories
      startDate
      endDate
      status
      pets {
        id
        firstName
        nickName
        lastName
      }
      franchise {
        id
        name
        address1
        address2
        city
        state
        zipcode
        country
        telephone
        fax
        latitude
        longitude
        email
        websiteUrl
      }
      items {
        id
        label
        displayName
        description
        code
        type {
          id
          label
          active
        }
        category {
          id
          label
          parentId
          typeId
          active
        }
        price
      }
    }
    vaccines {
      vaccinationStatus
      expiresOn
      memo
      vaccine {
        id
        name
        active
        required
        notes
      }
    }
    vets {
      vet {
        id
      }
    }
    numberOfUnverifiedPetVaccinations
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPetsWithStatusGQL extends Apollo.Query<GetPetsWithStatusQuery, GetPetsWithStatusQueryVariables> {
    document = GetPetsWithStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRelationContactsDocument = gql`
    query getRelationContacts($accountId: ID!) {
  getRelationContacts(accountId: $accountId) {
    id
    firstName
    lastName
    email
    phones {
      id
      countryCallingCode
      phoneNumber
      type
    }
    country
    address1
    address2
    city
    state
    zipcode
    isRelated
    relationship
    isEmergencyContact
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRelationContactsGQL extends Apollo.Query<GetRelationContactsQuery, GetRelationContactsQueryVariables> {
    document = GetRelationContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRelationContactDocument = gql`
    query getRelationContact($accountId: ID!, $relationContactId: ID!) {
  getRelationContact(accountId: $accountId, relationContactId: $relationContactId) {
    id
    firstName
    lastName
    email
    phones {
      id
      countryCallingCode
      phoneNumber
      type
    }
    country
    address1
    address2
    city
    state
    zipcode
    isRelated
    relationship
    isEmergencyContact
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRelationContactGQL extends Apollo.Query<GetRelationContactQuery, GetRelationContactQueryVariables> {
    document = GetRelationContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTermPolicyFormsDocument = gql`
    query getTermPolicyForms($franchiseId: ID) {
  getTermPolicyForms(franchiseId: $franchiseId) {
    id
    version
    templateId
    geoCountry {
      id
      countryIso
      name
      countryCallingCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTermPolicyFormsGQL extends Apollo.Query<GetTermPolicyFormsQuery, GetTermPolicyFormsQueryVariables> {
    document = GetTermPolicyFormsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservationRequestDocument = gql`
    query getReservationRequest($reservationRequestId: ID!) {
  getReservationRequest(reservationRequestId: $reservationRequestId) {
    id
    title
    type
    categories
    startDate
    endDate
    status
    pets {
      id
      firstName
      nickName
      lastName
    }
    franchise {
      id
      name
      address1
      address2
      city
      state
      zipcode
      country
      telephone
      fax
      latitude
      longitude
      email
      websiteUrl
    }
    items {
      id
      label
      displayName
      description
      code
      type {
        id
        label
        active
      }
      category {
        id
        label
        parentId
        typeId
        active
      }
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReservationRequestGQL extends Apollo.Query<GetReservationRequestQuery, GetReservationRequestQueryVariables> {
    document = GetReservationRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReservationRequestsDocument = gql`
    query getReservationRequests($accountId: ID!) {
  getReservationRequests(accountId: $accountId) {
    id
    title
    type
    categories
    startDate
    endDate
    status
    pets {
      id
      firstName
      nickName
      lastName
    }
    franchise {
      id
      name
      address1
      address2
      city
      state
      zipcode
      country
      telephone
      fax
      latitude
      longitude
      email
      websiteUrl
    }
    items {
      id
      label
      displayName
      description
      code
      type {
        id
        label
        active
      }
      category {
        id
        label
        parentId
        typeId
        active
      }
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReservationRequestsGQL extends Apollo.Query<GetReservationRequestsQuery, GetReservationRequestsQueryVariables> {
    document = GetReservationRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSignatureRequestDocument = gql`
    query getSignatureRequest($documentId: String!) {
  getSignatureRequest(documentId: $documentId) {
    testMode
    signatureRequestId
    requesterEmailAddress
    title
    originalTitle
    subject
    message
    createdAt
    isComplete
    isDeclined
    hasError
    finalCopyUri
    filesUrl
    signingUrl
    detailsUrl
    signingRedirectUrl
    customFields {
      name
      type
      value
      required
      apiId
      editor
    }
    responseData {
      apiId
      signatureId
      name
      value
      required
      type
    }
    signatures {
      signedAt
      signerName
      signerRole
      signatureId
      signerEmailAddress
      signerRole
      order
      statusCode
      declineReason
      signedAt
      lastViewedAt
      lastRemindedAt
      hasPin
      reassignedBy
      reassignmentReason
      error
    }
    embeddedSignUrl
    warningMsg
    warningName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSignatureRequestGQL extends Apollo.Query<GetSignatureRequestQuery, GetSignatureRequestQueryVariables> {
    document = GetSignatureRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSignatureRequestFilesDocument = gql`
    query getSignatureRequestFiles($accountTermPolicyFormId: ID!) {
  getSignatureRequestFiles(accountTermPolicyFormId: $accountTermPolicyFormId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSignatureRequestFilesGQL extends Apollo.Query<GetSignatureRequestFilesQuery, GetSignatureRequestFilesQueryVariables> {
    document = GetSignatureRequestFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingBookingDocument = gql`
    query getUpcomingBooking($bookingId: ID!) {
  getUpcomingBooking(bookingId: $bookingId) {
    id
    title
    type
    categories
    startDate
    endDate
    status
    declineReason
    pets {
      id
      firstName
      nickName
      lastName
    }
    items {
      id
      label
      displayName
      description
      code
      type {
        id
        label
        active
      }
      category {
        id
        label
        parentId
        typeId
        active
      }
      price
    }
    franchise {
      id
      name
      address1
      address2
      city
      state
      zipcode
      country
      telephone
      fax
      latitude
      longitude
      email
      websiteUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUpcomingBookingGQL extends Apollo.Query<GetUpcomingBookingQuery, GetUpcomingBookingQueryVariables> {
    document = GetUpcomingBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingBookingsDocument = gql`
    query getUpcomingBookings($accountId: ID!) {
  getUpcomingBookings(accountId: $accountId) {
    id
    title
    type
    categories
    startDate
    endDate
    status
    declineReason
    pets {
      id
      firstName
      nickName
      lastName
    }
    franchise {
      id
      name
      address1
      address2
      city
      state
      zipcode
      country
      telephone
      fax
      latitude
      longitude
      email
      websiteUrl
    }
    items {
      id
      label
      displayName
      description
      code
      type {
        id
        label
        active
      }
      category {
        id
        label
        parentId
        typeId
        active
      }
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUpcomingBookingsGQL extends Apollo.Query<GetUpcomingBookingsQuery, GetUpcomingBookingsQueryVariables> {
    document = GetUpcomingBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVisitedLocationsDocument = gql`
    query getVisitedLocations($accountId: ID!) {
  getVisitedLocations(accountId: $accountId) {
    id
    code
    name
    address1
    address2
    city
    state
    zipcode
    country
    email
    telephone
    tax
    websiteUrl
    homeBuddiesUrl
    hasDefaultTipItem
    merchant {
      id
      merchTippercent
    }
    creditCardProcessingEnabled
    hoursOfOperation {
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVisitedLocationsGQL extends Apollo.Query<GetVisitedLocationsQuery, GetVisitedLocationsQueryVariables> {
    document = GetVisitedLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWaitlistBookingDocument = gql`
    query getWaitlistBooking($waitlistBookingId: ID!) {
  getWaitlistBooking(waitlistBookingId: $waitlistBookingId) {
    id
    title
    type
    categories
    startDate
    endDate
    status
    pets {
      id
      firstName
      nickName
      lastName
    }
    franchise {
      id
      name
      address1
      address2
      city
      state
      zipcode
      country
      telephone
      fax
      latitude
      longitude
      email
      websiteUrl
    }
    items {
      id
      label
      displayName
      description
      code
      type {
        id
        label
        active
      }
      category {
        id
        label
        parentId
        typeId
        active
      }
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWaitlistBookingGQL extends Apollo.Query<GetWaitlistBookingQuery, GetWaitlistBookingQueryVariables> {
    document = GetWaitlistBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWaitlistBookingsDocument = gql`
    query getWaitlistBookings($accountId: ID!) {
  getWaitlistBookings(accountId: $accountId) {
    id
    title
    type
    categories
    startDate
    endDate
    status
    pets {
      id
      firstName
      nickName
      lastName
    }
    franchise {
      id
      name
      address1
      address2
      city
      state
      zipcode
      country
      telephone
      fax
      latitude
      longitude
      email
      websiteUrl
    }
    items {
      id
      label
      displayName
      description
      code
      type {
        id
        label
        active
      }
      category {
        id
        label
        parentId
        typeId
        active
      }
      price
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWaitlistBookingsGQL extends Apollo.Query<GetWaitlistBookingsQuery, GetWaitlistBookingsQueryVariables> {
    document = GetWaitlistBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HasExistingReservationsDocument = gql`
    query hasExistingReservations($reservationService: ReservationServiceInput!) {
  hasExistingReservations(reservationService: $reservationService) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HasExistingReservationsGQL extends Apollo.Query<HasExistingReservationsQuery, HasExistingReservationsQueryVariables> {
    document = HasExistingReservationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsEmailExistDocument = gql`
    query isEmailExist($email: String!) {
  isEmailExist(email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsEmailExistGQL extends Apollo.Query<IsEmailExistQuery, IsEmailExistQueryVariables> {
    document = IsEmailExistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }